(function() {
  'use strict';

  angular
    .module('madBackWeb', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'toastr', 'angularQFileUpload', 'LocalStorageModule']);

})();

(function() {
  'use strict';

  angular
      .module('madBackWeb')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .controller('subNavbarCtrl', subNavbarCtrl);

  /** @ngInject */
  function subNavbarCtrl($scope, $location) {
    $scope.user = false;
    $scope.advert = false;

    $scope.userlist = false;
    $scope.adduser = false;
    $scope.userauth = false;

    $scope.adpush = false;
    $scope.adupload = false;
    $scope.adaduit = false;
    $scope.adsearch = false;

    $scope.finance = false;
    $scope.financecash = false;
    $scope.financerefund = false;
    // console.log($location.path());
    if ($location.path() == '/user/list-mobile') {
      $scope.user = true;
    }
    if ($location.path() == '/user/list-mobileuser/list-advert') {
      $scope.advert = true;
    }

    if ($location.path() == '/admin/auth') {
      $scope.userauth = true;
    }
    if ($location.path() == '/admin/userlist') {
      $scope.userlist = true;
    }
    if ($location.path() == '/admin/adduser') {
      $scope.adduser = true;
    }

    if ($location.path() == '/advert/push') {
      $scope.adpush = true;
    }
    if ($location.path() == '/advert/upload') {
      $scope.adupload = true;
    }
    if ($location.path() == '/advert/audit') {
      $scope.adaduit = true;
    }
    if ($location.path() == '/advert/search') {
      $scope.adsearch = true;
    }

    if ($location.path() == '/finance') {
      $scope.finance = true;
    }

    if ($location.path() == '/finance/cash') {
      $scope.financecash = true;
    }

    if ($location.path() == '/finance/refund') {
      $scope.financerefund = true;
    }

    if ($location.path() == '/finance/recharge') {
      $scope.financerecharge = true;
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .controller('navbarCtrl', navbarCtrl)
    .directive('myAccess', myAccess);

  /** @ngInject */
  function navbarCtrl($scope, $location, $state) {
    $scope.isMain = false;
    $scope.isUserManage = false;
    $scope.isAdManage = false;
    $scope.isFinanceManage = false;
    $scope.isAdmin = false;
    $scope.isStatistics = false;

    if ($location.path() == '/') {
      $scope.isMain = true;
    }

    if ($location.path() == '/user/list-mobile' ||
        $location.path() == '/user/list-mobileuser/list-advert' ||
        $location.path() == '/user/list-mobileuser/create') {
      $scope.isUserManage = true;
    }

    if ($location.path() == '/advert/push' ||
        $location.path() == '/advert/upload' ||
        $location.path() == '/advert/audit' ||
        $location.path() == '/advert/search') {
      $scope.isAdManage = true;
    }

    if ($location.path() == '/finance' ||
        $location.path() == '/finance/cash' ||
        $location.path() == '/finance/refund' ||
        $location.path() == '/finance/recharge') {
      $scope.isFinanceManage = true;
    }

    if ($location.path() == '/admin/userlist' ||
        $location.path() == '/admin/adduser' ||
        $location.path() == '/admin/auth') {
      $scope.isAdmin = true;
    }

    if ($location.path() == '/statistics') {
      $scope.isStatistics = true;
    }
  }

  function myAccess ($window) {
    return {
      restrict: 'A',
      link: function (scope, element, attributes) {
        var allowedAccess = attributes.myAccess;
        if ($window.localStorage['LEVEL'] === '1') {
          scope.display = 'inline';
        }
        else scope.display = 'none';
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('madBackWeb')
    .controller('HeaderCtrl', HeaderCtrl);

    /** @ngInject */
    function HeaderCtrl ($scope, $rootScope, $state, $window, MessageSrv, MessageStatusSrv, DeleteMsgSrv, NoticeSrv, ErrorSrv) {
      $scope.logout = function () {
        $window.localStorage.removeItem('token');
        $window.localStorage.removeItem('LEVEL');
        $window.localStorage.removeItem('adminId');
        $window.localStorage.removeItem('upToken');
        $state.go('app.login');
        NoticeSrv.notice("您已成功登出");
      }

      $scope.markMsg = function () {
        MessageStatusSrv.changeStatus().save({
          id: $window.localStorage['adminId']
        })
        .$promise.then(
          function (response) {
            // console.log(response.errCode);
          }
        ),
        function (error) {
          console.log(error);
        }
      }

      $scope.refresh = function () {
        $state.reload();
      }

      $scope.delete = function (id) {
        DeleteMsgSrv.deleteMsg().save({
          id: id,
          adminId: $window.localStorage['adminId']
        }).$promise.then(
          function (response) {
            NoticeSrv.success("成功删除消息");
            $state.reload();
          },
          function (error) {
            console.log(error);
          }
        )
      }

      MessageSrv.getMessage().get({
        id: $window.localStorage['adminId']
      }).$promise.then(
        function (response) {
          $rootScope.msgList = response.MsgList.reverse();
          var number = 0;
          for (var msg in response.MsgList) {
            if ((response.MsgList)[msg].status == 0) {
              response.MsgList[msg].color = 'text-danger';
              number++;
            } else {
              response.MsgList[msg].color = 'text-info';
            }
          }
          $rootScope.msg = {
            number: number
          }
        }
      ), function (error) {
        console.log(error);
      }
    }

})();

(function() {
  'use strict';

  angular
  .module('madBackWeb')
  .controller('UserListCtrl', UserListCtrl);

  /** @ngInject */
  function UserListCtrl($rootScope, $scope, $state, UserListSrv, GetUserDetailSrv) {
    var tag = 1;
    UserListSrv.getUserInfo().get({
      tag: tag
    }).$promise.then(
      function (response) {
        var list = response.userList;
        for (var user in list) {
          if (list[user].status == '010') {
            list[user].state = '待审核';
            list[user].statusClass = 'label-info';
            list[user].uiSref = 'app.user.check-mobile';
            list[user].operator = '审核用户';
          }
          if (list[user].status == '100') {
             list[user].state = '审核通过';
             list[user].statusClass = 'label-success';
             list[user].uiSref = 'app.user.detail-mobile';
             list[user].operator = '用户详情';
           }
          if (list[user].status == '001') {
            list[user].state = '审核未通过';
            list[user].statusClass = 'label-danger';
            list[user].uiSref = 'app.user.detail-mobile';
            list[user].operator = '用户详情';
          }
        }
        // $scope.userList = list;
        $scope.filter = {};

        $scope.currentPage = 1
        ,$scope.numPerPage = 5
        ,$scope.maxSize = 10
        ,$scope.length = list.length;
        $scope.$watch("currentPage + numPerPage", function() {
          var begin = (($scope.currentPage - 1) * $scope.numPerPage)
          , end = begin + $scope.numPerPage;
          // console.log(begin + ' | ' + end);
          $scope.userList = list.slice(begin, end);
        });


        $scope.filterByCategory = function (user) {
          return $scope.filter[user.status] || noFilter($scope.filter);
        }
        function noFilter(filterObj) {
          for (var key in filterObj) {
              if (filterObj[key]) {
                  return false;
              }
          }
          return true;
        }
      }, function (error) {
        console.log(error);
      }
    )

    $scope.getDetailById = function (id) {
      GetUserDetailSrv.getUserDetailById().get({
        userid: id,
        tag: tag
      }).$promise.then(
        function (response) {
          $rootScope.mobile = {
            name: response.userDetail.name,
            id: response.userDetail.id,
            // location: response.userDetail.location,
            vehicleLicenseImage: response.userDetail.vehicleLicenseImage,
            // email: response.userDetail.email,
            mobilePhone: response.userDetail.mobilePhone
          }
        }, function (error) {
          console.log(error);
        }
      )
    }

    $scope.categories = [{
      name: '等待审核',
      labelClass: 'label-info',
      info: '待审核',
      status: '010'
    },{
      name: '审核通过',
      labelClass: 'label-success',
      info: '审核通过',
      status: '100'
    },{
      name: '审核未通过',
      labelClass: 'label-danger',
      info: '审核未通过',
      status: '001'
    }];
  }

})();

(function() {
  'use strict';

  angular
  .module('madBackWeb')
  .controller('AdvertListCtrl', AdvertListCtrl);

  /** @ngInject */
  function AdvertListCtrl($rootScope, $scope, $state, UserListSrv, GetUserDetailSrv) {
    var tag = 2;
    UserListSrv.getUserInfo().get({
      tag: tag
    }).$promise.then(
      function (response) {
        var list = response.advertiserList;
        for (var user in list) {
          if (list[user].status == '010') {
            list[user].state = '待审核';
            list[user].statusClass = 'label-info';
            list[user].uiSref = 'app.user.check-advert';
            list[user].operator = '审核广告商';
          }
          if (list[user].status == '100') {
            list[user].state = '审核通过';
             list[user].statusClass = 'label-success';
             list[user].uiSref = 'app.user.detail-advert';
             list[user].operator = '广告商详情';
           }
          if (list[user].status == '001') {
            list[user].state = '审核未通过';
            list[user].statusClass = 'label-danger';
            list[user].uiSref = 'app.user.detail-advert';
            list[user].operator = '广告商详情';
          }
        }
        $scope.currentPage = 1
        ,$scope.numPerPage = 5
        ,$scope.maxSize = 5
        ,$scope.length = list.length;
        $scope.$watch("currentPage + numPerPage", function() {
          var begin = (($scope.currentPage - 1) * $scope.numPerPage)
          , end = begin + $scope.numPerPage;
          // console.log(begin + ' | ' + end);
          $scope.userList = list.slice(begin, end);
        });

        // $scope.userList = filteredTodos;
        $scope.filter = {};
        $scope.filterByCategory = function (user) {
          return $scope.filter[user.status] || noFilter($scope.filter);
        }
        function noFilter(filterObj) {
          for (var key in filterObj) {
              if (filterObj[key]) {
                  return false;
              }
          }
          return true;
        }
      }, function (error) {
        console.log(error);
      }
    )

    $scope.getDetailById = function (id) {
      GetUserDetailSrv.getUserDetailById().get({
        userid: id,
        tag: tag
      }).$promise.then(
        function (response) {
          $rootScope.advert = {
            name: response.userDetail.name,
            id: response.userDetail.id,
            status: response.userDetail.status,
            email: response.userDetail.email,
            registerDate: response.userDetail.registerDate,
            type: response.userDetail.detail.type,
            licenseType: response.userDetail.detail.licenseType,
            licenseImage: response.userDetail.detail.licenseImage,
            licenseCode: response.userDetail.detail.licenseCode,
            location: response.userDetail.detail.location,
            accomodation: response.userDetail.detail.accomodation,
            businessScope: response.userDetail.detail.businessScope,
            businessPeriod: response.userDetail.detail.businessPeriod,
            organizationCode: response.userDetail.detail.organizationCode,
            legalPersonName: response.userDetail.detail.legalPerson.name,
            legalPersonLocation: response.userDetail.detail.legalPerson.location,
            legalPersonId: response.userDetail.detail.legalPerson.id,
            legalPersonValidDate: response.userDetail.detail.legalPerson.validDate,
            legalPersonIfLongTerm: response.userDetail.detail.legalPerson.ifLongTerm,
            legalPersonIfLegalPerson: response.userDetail.detail.legalPerson.ifLegalPerson
          }
          // console.log(response);
        }, function (error) {
          console.log(error);
        }
      )
    }

    $scope.categories = [{
      name: '等待审核',
      labelClass: 'label-info',
      info: '待审核',
      status: '010'
    },{
      name: '审核通过',
      labelClass: 'label-success',
      info: '审核通过',
      status: '100'
    },{
      name: '审核未通过',
      labelClass: 'label-danger',
      info: '审核未通过',
      status: '001'
    }];

  }

})();




(function () {
  'use strict';

  angular
  .module('madBackWeb')
  .directive('modal', modal)
  .controller('UserCheckCtrl', UserCheckCtrl);

  function UserCheckCtrl ($rootScope, $scope, $state, CheckUserSrv, NoticeSrv, ErrorSrv) {
    $scope.checkSuccess = function (id, tag) {
      var reason = '';
      CheckUserSrv.checkUser().save({
        id: id,
        tag: tag,
        success: 1,
        reason: reason
      }).$promise.then(
        function (response) {
          NoticeSrv.success("操作成功");
          if (tag == 1) $state.go('app.user');
          if (tag == 2) $state.go('app.user.list-advert');
        },
        function (error) {
          NoticeSrv.notice("操作失败");
          console.log(error);
        }
      )
    }

    $scope.checkFailure = function (id, tag, reason) {
      if (!reason) {
        NoticeSrv.error(ErrorSrv.getError('409'));
      } else {
        CheckUserSrv.checkUser().save({
          id: id,
          tag: tag,
          success: 0,
          reason: reason
        }).$promise.then(
          function (response) {
            NoticeSrv.success("操作成功");
          },
          function (error) {
            NoticeSrv.notice("操作失败");
            console.log(error);
          }
        )
      }
    }

  }

  function modal ($location, $state) {
    return {
      restrict: 'AE',
      require: 'ngModel',
      link: function (scope, element, attrs, ngModel) {
        element.bind("click", function() {
          var obj = $("#exampleModal");
          obj.modal('hide');
          setTimeout(function() {
            if ($location.path() == '/user/list-mobileuser/check-mobile') {
              $state.go('app.user');
            }
            else if ($location.path() == '/user/list-mobileuser/check-advert') {
              $state.go('app.user.list-advert');
            }
          }, 1000);
          scope.$apply(function(){
            // scope.back = true;
            scope.pass = true;
            scope.notPass = true;
          })
        });
      }
    }
  }

})();


(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .controller('UploadCtrl', UploadCtrl);

    function UploadCtrl($scope, $log, $qupload, $window) {
      $scope.selectFiles = [];
      // console.log($window.localStorage['upToken']);
  		var start = function (index) {
  			$scope.selectFiles[index].progress = {
  				p: 0
  			};
  			$scope.selectFiles[index].upload = $qupload.upload({
  				key: $scope.selectFiles[index].file.name.split('.')[0],
  				file: $scope.selectFiles[index].file,
          token: $window.localStorage['upToken']
  			});
  			$scope.selectFiles[index].upload.then(function (response) {
  				$log.info(response);
          $scope.upload = {
            result: 'success',
            picUrl: 'http://o7epbv9gm.bkt.clouddn.com/' + response.key,
            isSuccess: true
          }
  			}, function (response) {
  				$log.info(response);
          $scope.upload = {
            result: 'failure',
            isSuccess: false
          }
  			}, function (evt) {
  				$scope.selectFiles[index].progress.p = Math.floor(100 * evt.loaded / evt.totalSize);
  			});
  		};

  		$scope.abort = function (index) {
  			$scope.selectFiles[index].upload.abort();
  			$scope.selectFiles.splice(index, 1);
  		};

  		$scope.onFileSelect = function ($files) {
  			var offsetx = $scope.selectFiles.length;
  			for (var i = 0; i < $files.length; i++) {
  				$scope.selectFiles[i + offsetx] = {
  					file: $files[i]
  				};
  				start(i + offsetx);
  			}
  		}
    }

})();

(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .controller('StatisticsCtrl', StatisticsCtrl);

  /** @ngInject */
  function StatisticsCtrl($rootScope, $scope, $state, StatisticsSrv) {
    StatisticsSrv.getStatistics().get()
    .$promise.then(
      function (response) {
        var newData = [];
        response.statistics.forEach(function(obj, i) {
          if (i === 0) {
            newData.push({
              month: (new Date(obj.date)).getMonth() + 1,
              income: obj.totalIncome,
              broadcast: obj.totalBroadcast
            })
          } else {
            newData.forEach(function(o) {
              if ((new Date(obj.date)).getMonth() + 1 === o.month) {
                o.income += obj.totalIncome;
                o.broadcast += obj.totalBroadcast;
              } else {
                newData.push({
                  month: (new Date(obj.date)).getMonth() + 1,
                  income: obj.totalIncome,
                  broadcast: obj.totalBroadcast
                })
              }
            })
          }
        })

        var chart = AmCharts.makeChart("chartdiv", {
          "type": "serial",
          "theme": "light",
          "marginRight": 40,
          "marginLeft": 40,
          "autoMarginOffset": 20,
          "mouseWheelZoomEnabled":true,
          "dataDateFormat": "YYYY-MM-DD",
          "valueAxes": [{
              "id": "v1",
              "axisAlpha": 0,
              "position": "left",
              "ignoreAxisWidth":true
          }],
          "balloon": {
              "borderThickness": 1,
              "shadowAlpha": 0
          },
          "graphs": [{
              "id": "g1",
              "balloon":{
              "drop":true,
              "adjustBorderColor":false,
              "color":"#ffffff"
              },
              "bullet": "round",
              "bulletBorderAlpha": 1,
              "bulletColor": "#FFFFFF",
              "bulletSize": 5,
              "hideBulletsCount": 50,
              "lineThickness": 2,
              "title": "red line",
              "useLineColorForBulletBorder": true,
              "valueField": "totalIncome",
              "balloonText": "<span style='font-size:18px;'>[[totalIncome]]</span>"
          }],
          "chartScrollbar": {
              "graph": "g1",
              "oppositeAxis":false,
              "offset":30,
              "scrollbarHeight": 80,
              "backgroundAlpha": 0,
              "selectedBackgroundAlpha": 0.1,
              "selectedBackgroundColor": "#888888",
              "graphFillAlpha": 0,
              "graphLineAlpha": 0.5,
              "selectedGraphFillAlpha": 0,
              "selectedGraphLineAlpha": 1,
              "autoGridCount":true,
              "color":"#AAAAAA"
          },
          "chartCursor": {
              "pan": true,
              "valueLineEnabled": true,
              "valueLineBalloonEnabled": true,
              "cursorAlpha":1,
              "cursorColor":"#258cbb",
              "limitToGraph":"g1",
              "valueLineAlpha":0.2
          },
          "valueScrollbar":{
            "oppositeAxis":false,
            "offset":50,
            "scrollbarHeight":10
          },
          "categoryField": "date",
          "categoryAxis": {
              "parseDates": true,
              "dashLength": 1,
              "minorGridEnabled": true
          },
          "export": {
              "enabled": true
          },
          "dataProvider": response.statistics
      });

      chart.addListener("rendered", zoomChart);

      zoomChart();

      function zoomChart() {
          chart.zoomToIndexes(chart.dataProvider.length - 40, chart.dataProvider.length - 1);
      }

      var chart = AmCharts.makeChart( "incomeChart", {
          "type": "serial",
          "addClassNames": true,
          "theme": "light",
          "autoMargins": false,
          "marginLeft": 30,
          "marginRight": 8,
          "marginTop": 10,
          "marginBottom": 26,
          "balloon": {
              "adjustBorderColor": false,
              "horizontalPadding": 10,
              "verticalPadding": 8,
              "color": "#ffffff"
          },

          "dataProvider": newData,
          "startDuration": 1,
          "graphs": [ {
              "alphaField": "alpha",
              "balloonText": "<span style='font-size:12px;'>[[title]] in [[category]]:<br><span style='font-size:20px;'>[[value]]</span></span>",
              "fillAlphas": 1,
              "title": "Income",
              "type": "column",
              "valueField": "income",
              "dashLengthField": "dashLengthColumn"
          }, {
              "id": "graph2",
              "balloonText": "<span style='font-size:12px;'>[[title]] in [[category]]:<br><span style='font-size:20px;'>[[value]]</span></span>",
              "bullet": "round",
              "lineThickness": 3,
              "bulletSize": 7,
              "bulletBorderAlpha": 1,
              "bulletColor": "#FFFFFF",
              "useLineColorForBulletBorder": true,
              "bulletBorderThickness": 3,
              "fillAlphas": 0,
              "lineAlpha": 1,
              "title": "Broadcast",
              "valueField": "broadcast",
              "dashLengthField": "dashLengthLine"
          } ],
          "categoryField": "month",
          "categoryAxis": {
              "gridPosition": "start",
              "axisAlpha": 0,
              "tickLength": 0
          },
          "export": {
              "enabled": true
          }
        });
      }
    ),
    function (error) {
      console.log(error);
    }
  }

})();

(function() {
  'use strict';

  angular
  .module('madBackWeb')
  .service('UserListSrv', UserListSrv);

  /** @ngInject*/
  function UserListSrv($resource, baseURL) {
    this.getUserInfo = function () {
      return $resource(baseURL + '/user/list?tag=:tag', {
        tag: "@tag"
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .factory('TokenSrv', TokenSrv);

    /** @ngInject */
    function TokenSrv($window) {
        return {
          setToken: function (token) {
            $window.localStorage['token'] = token;
          },
          getToken: function () {
            return $window.localStorage['token'];
          }
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .factory('NoticeSrv', NoticeSrv);

  /** @ngInject */
    function NoticeSrv($compile, $timeout, $rootScope) {
        var notification = {};
        notification.timer = null;
        notification.__alert__ = function(css, title, text) {
            var template = ['<div class="notice fixed alert alert-dismissible ',
                          css,
                          '">',
                          '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>',
                          '<strong>',
                          title,
                          '</strong>',
                          text,
                          '</div>'].join('');
            if (angular.element(document).find('.notice')) {
                angular.element(document).find('.notice').remove();
            }
            if (this.timer) {
                $timeout.cancel(this.timer);
            }
            angular.element(document).find('body').append($compile(template)($rootScope));
            this.timer = $timeout(function() {
                angular.element(document).find('.notice').remove();
            }, 5000);
        };

        notification.success = function(text) {
            this.__alert__('alert-success', '成功: ', text);
        };

        notification.error = function(text) {
            this.__alert__('alert-danger', '错误: ', text);
        };

        notification.notice = function(text) {
            this.__alert__('alert-info', '提示: ', text);
        };

        return notification;
    }
})();

(function() {
  'use strict';

  angular
  .module('madBackWeb')
  .service('MessageSrv', MessageSrv)
  .service('MessageStatusSrv', MessageStatusSrv)
  .service('DeleteMsgSrv', DeleteMsgSrv);

  /** @ngInject*/
  function MessageSrv($resource, baseURL) {
    this.getMessage = function () {
      return $resource(baseURL + '/message/list?id=:id', {
        id: "@id"
      });
    }
  }

  function MessageStatusSrv($resource, baseURL) {
    this.changeStatus = function () {
      return $resource(baseURL + '/message/status?id=:id');
    }
  }

  function DeleteMsgSrv($resource, baseURL) {
    this.deleteMsg = function () {
      return $resource(baseURL + '/message/delete');
    }
  }

})();

(function() {
  'use strict';

  angular
  .module('madBackWeb')
  .service('LoginSrv', LoginSrv);

  /** @ngInject*/
  function LoginSrv($resource, baseURL) {
    this.adminLogin = function () {
      return $resource(baseURL + '/login');
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .factory('myInterceptor', myInterceptor);

    /** @ngInject */
    function myInterceptor($rootScope, $injector, TokenSrv, baseURL) {
      var myInterceptor = {
        request: function (config) {
          if (arguments[0].url.indexOf(baseURL) !== -1) {
            if (arguments[0].method === 'GET' || arguments[0].method === 'DELETE' || arguments[0].method === 'OPTIONS') {
              arguments[0].params = arguments[0].params || {};
              arguments[0].params.token = TokenSrv.getToken();
            }
            if (arguments[0].method === 'POST' || arguments[0].method === 'PUT') {
              arguments[0].data = arguments[0].data || {};
              arguments[0].data.token = TokenSrv.getToken();
            }
          }
          return config;
        },
        response: function (response) {
          // console.log(response);
          if (response.data.errCode === 101) {
            $injector.get('NoticeSrv').notice($injector.get('ErrorSrv').getError(response.data.errCode));
            var $state = $injector.get('$state');
            $state.go('app.login');
          }
          if (response.data.errCode && response.data.errCode !== 0) {
            $injector.get('NoticeSrv').error($injector.get('ErrorSrv').getError(response.data.errCode));
            var $state = $injector.get('$state');
            $state.go('app.login');
          }
          return response;
        }
      };
      return myInterceptor;
    }
})();

(function() {
  'use strict';

angular
  .module('madBackWeb')
  .service('financeListSrv', financeListSrv);

  /** @ngInject*/
  function financeListSrv($resource, baseURL) {
    this.getFinanceList = function () {
      return $resource(baseURL + '/account/list');
    }

  	this.getApplyList = function() {
  		return $resource(baseURL + '/account/apply/list');
  	}

  	this.completeApply = function() {
  		return $resource(baseURL + '/account/apply/complete');
  	}
  }



})();

(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .factory('ErrorSrv', processError);

  /** @ngInject */
  function processError() {
    var error, getError;
    error = {
      '101': '令牌不存在或已经过期, 请重新登陆',
      '102':'用户名或密码错误',
      '108':'请求错误',
      '401':'该用户ID不存在',
      '402':'经办人用户名密码错误',
      '403':'该申请不存在',
      '404':'该后台用户已存在',
      '405':'后台用户权限错误',
      '406':'该后台用户不存在',
      '407':'登录名不能为空',
      '408':'登录密码不能为空',
      '409':'审核未通过理由不能为空',
      '410':'管理员的姓名不能为空',
      '411':'管理员的邮箱不能为空',
      '412':'管理员的性别不能为空',
      '413':'管理员的管理级别不能为空',
      '414':'管理员的上任时间不能为空',
      '415':'参数不完整',
      '416':'密码不能为空',
      '417':'两次密码不一致',
      '418':'密码修改成功!请重新登录',
      '419':'密码长度至少为8位',
      '999':'未知错误'
    };
    getError = function(errCode) {
      return error[errCode];
    };
    return {
      getError: getError
    };
  }
})();

(function () {
  'use strict';

  angular
  .module('madBackWeb')
  .service('DashboardSrv', DashboardSrv)
  .service('StatisticsSrv', StatisticsSrv)

  /** @ngInject*/
  function DashboardSrv($resource, baseURL) {
    this.getDashboardData = function () {
      return $resource(baseURL + '/home');
    }
  }

  function StatisticsSrv($resource, baseURL) {
    this.getStatistics = function () {
      return $resource(baseURL + '/statistics/dayincome');
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('madBackWeb')
  .service('GetUserDetailSrv', GetUserDetailSrv)
  .service('CheckUserSrv', CheckUserSrv);

  /** @ngInject*/
  function GetUserDetailSrv ($resource, baseURL) {
    this.getUserDetailById = function () {
      return $resource(baseURL + '/user/detail/:userid?tag=:tag', {
        userid: "userId",
        tag: "@tag"
      });
    };
  }

  function CheckUserSrv ($resource, baseURL) {
    this.checkUser = function () {
      return $resource(baseURL + '/user/audit');
    }
  }

})();

(function() {
  'use strict';

  angular
  .module('madBackWeb')
  .service('BackUserListSrv', BackUserListSrv)
  .service('AddBackUserSrv', AddBackUserSrv)
  .service('UpdateLevelSrv', UpdateLevelSrv)
  .service('UpdateAdminInfoSrv', UpdateAdminInfoSrv);

  /** @ngInject*/
  function BackUserListSrv($resource, baseURL) {
    this.getBackUserInfo = function () {
      return $resource(baseURL + '/backuser/list');
    }
  }

  function  AddBackUserSrv($resource, baseURL) {
    this.addBackUser = function () {
      return $resource(baseURL + '/backuser/create');
    }
  }

  function UpdateLevelSrv($resource, baseURL) {
    this.updateAdminLevel = function () {
      return $resource(baseURL + '/backuser/manage');
    }
  }

  function UpdateAdminInfoSrv($resource, baseURL) {
    this.updateAdminInfo = function () {
      return $resource(baseURL + '/backuser/modify');
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('madBackWeb')
  .service('adsListSrv', adsListSrv)
  .service('adDetailSrv', adDetailSrv)
  .service('auditAdsSrv', auditAdsSrv)
  .service('searchAdsSrv', searchAdsSrv);

  /** @ngInject*/
  function adsListSrv($resource, baseURL) {
    this.getNotAuditList = function () {
      return $resource(baseURL + '/advert/list/all');
    }
  }

  function adDetailSrv($resource, baseURL) {
    this.getAdDetail = function () {
      return $resource(baseURL + '/advert/detail');
    }
  }

  function auditAdsSrv($resource, baseURL) {
    this.auditAds = function(){
      return $resource(baseURL + '/advert/audit');
    }

    this.removeAds = function(){
      return $resource(baseURL + '/advert/remove');
    }

  }

  function searchAdsSrv($resource, baseURL) {
    this.searchAds = function() {
      return $resource(baseURL + '/advert/search');
    }
  }

})();
(function () {
  'use strict';

  angular
    .module('madBackWeb')
    .controller('LoginCtrl', LoginCtrl);

    function LoginCtrl ($scope, $state, LoginSrv, TokenSrv, $window, NoticeSrv) {
      $scope.login = function (username, password) {
        LoginSrv.adminLogin().save({
          name: username,
          password: password
        }).$promise.then(
          function (response) {
            if (response.errCode == 0 && (response.token && response.token != 'undefined')) {
              $window.localStorage['adminId'] = response.id;
              TokenSrv.setToken(response.token);
              $window.localStorage['LEVEL'] = response.level;
              $window.localStorage['upToken'] = response.uptoken;
              NoticeSrv.success("登录成功");
              $state.go('app');
            } else {
              $state.go('app.login');
            }
          }, function (error) {
            console.log(error);
          }
        )
      }
    }

})();

(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .controller('refundApplyCtrl', refundApplyCtrl);

   /** @ngInject */
  function refundApplyCtrl($scope, $state, financeListSrv) {
  	financeListSrv.getApplyList().save({},{
      catalog: 2
    })
  	.$promise.then(
      function (response) {
      	// console.log(response);
        // 分页
        $scope.currentPage = 1
        ,$scope.numPerPage = 5
        ,$scope.maxSize = 5
        ,$scope.length = response.applyList.length;
        $scope.$watch("currentPage + numPerPage", function() {
          var begin = (($scope.currentPage - 1) * $scope.numPerPage)
          , end = begin + $scope.numPerPage;
          // console.log(begin + ' | ' + end);
          $scope.refundApplyList = response.applyList.slice(begin, end);
        });
      	// $scope.refundApplyList = response.applyList;
      }, function (error) {
        console.log(error);
      }
    );

    $scope.completeCash = function(username, password, tag, id){
      console.log(id);
    financeListSrv.completeApply().save({},{
      operatorEmail: username,
      operatorPassword: password,
      applyId: id,
      tag: tag
    })
    .$promise.then(
      function (response) {
        console.log(response.errCode);
        if(response.errCode == 0){
          alert("操作成功");
          window.location.reload();
        }else{
          alert("操作失败");
          window.location.reload();
        };
      }, function (error) {
        console.log(error);
      }
    );
    }


    $scope.pass = function(id){
      $scope.tag = 1;
      $scope.applyId = id;
    }

    $scope.reject = function(id){
      $scope.tag = 0;
      $scope.applyId = id;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .controller('rechargeApplyCtrl', rechargeApplyCtrl);

   /** @ngInject */
  function rechargeApplyCtrl($scope, $state, financeListSrv) {
  	financeListSrv.getApplyList().save({},{
  		catalog: 1
  	})
  	.$promise.then(
      function (response) {
      	// console.log(response);
        // 分页
        $scope.currentPage = 1
        ,$scope.numPerPage = 5
        ,$scope.maxSize = 5
        ,$scope.length = response.applyList.length;
        $scope.$watch("currentPage + numPerPage", function() {
          var begin = (($scope.currentPage - 1) * $scope.numPerPage)
          , end = begin + $scope.numPerPage;
          // console.log(begin + ' | ' + end);
          $scope.rechargeApplyList = response.applyList.slice(begin, end);
        });
      	// $scope.rechargeApplyList = response.applyList;
      }, function (error) {
        console.log(error);
      }
    );

    $scope.pass = function(id){
      $scope.tag = 1;
      $scope.applyId = id;
    }

    $scope.reject = function(id){
      $scope.tag = 0;
      $scope.applyId = id;
    }

    $scope.completeRecharge = function(username, password, tag, id){
      console.log(id);
    financeListSrv.completeApply().save({},{
      operatorEmail: username,
      operatorPassword: password,
      applyId: id,
      tag: tag
    })
    .$promise.then(
      function (response) {
        console.log(response.errCode);
        if(response.errCode == 0){
          alert("操作成功");
          window.location.reload();
        }else{
          alert("操作失败");
          window.location.reload();
        };
      }, function (error) {
        console.log(error);
      }
    );
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .controller('cashApplyCtrl', cashApplyCtrl);

   /** @ngInject */
  function cashApplyCtrl($scope, $state, financeListSrv) {
  	financeListSrv.getApplyList().save({},{
      catalog: 3
    })
  	.$promise.then(
      function (response) {
      	// console.log(response);
        // 分页
        $scope.currentPage = 1
        ,$scope.numPerPage = 5
        ,$scope.maxSize = 5
        ,$scope.length = response.applyList.length;

        $scope.$watch("currentPage + numPerPage", function() {
          var begin = (($scope.currentPage - 1) * $scope.numPerPage)
          , end = begin + $scope.numPerPage;
          // console.log(begin + ' | ' + end);
          $scope.cashApplyList = response.applyList.slice(begin, end);
        });

      	// $scope.cashApplyList = response.applyList;
      }, function (error) {
        console.log(error);
      }
    );

    $scope.completeCash = function(username, password, tag, id){
      console.log(id);
    financeListSrv.completeApply().save({},{
      operatorEmail: username,
      operatorPassword: password,
      applyId: id,
      tag: tag
    })
    .$promise.then(
      function (response) {
        console.log(response.errCode);
        if(response.errCode == 0){
          alert("操作成功");
          window.location.reload();
        }else{
          alert("操作失败");
          window.location.reload();
        };
      }, function (error) {
        console.log(error);
      }
    );
    }

    $scope.pass = function(id){
      $scope.tag = 1;
      $scope.applyId = id;
    }

    $scope.reject = function(id){
      $scope.tag = 0;
      $scope.applyId = id;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .controller('FinanceDetailCtrl', FinanceDetailCtrl);

   /** @ngInject */
  function FinanceDetailCtrl($scope, $state, financeListSrv) {
  	financeListSrv.getFinanceList().save()
  	.$promise.then(
      function (response) {
      	// console.log(response);
        $scope.currentPage = 1
        ,$scope.numPerPage = 5
        ,$scope.maxSize = 5
        ,$scope.length = response.accountList.length;

        $scope.$watch("currentPage + numPerPage", function() {
          var begin = (($scope.currentPage - 1) * $scope.numPerPage)
          , end = begin + $scope.numPerPage;
          // console.log(begin + ' | ' + end);
          for (var i = 0; i < response.accountList.length; i++) {
            if(response.accountList[i].catalog == "1") response.accountList[i].catalog ="广告商充值申请";
            else if(response.accountList[i].catalog == "2") response.accountList[i].catalog ="广告商退款申请";
            else if(response.accountList[i].catalog == "3") response.accountList[i].catalog ="车主用户提现申请";
            
          }
          $scope.financeList = response.accountList.slice(begin, end);
        });
      	// $scope.financeList = response.accountList;
      }, function (error) {
        console.log(error);
      }
    );

  }

})();

(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($rootScope, $scope, $state, DashboardSrv) {
    DashboardSrv.getDashboardData().get()
    .$promise.then(
      function (response) {
        // console.log(response);
        // 总量和昨日投放量
        var last = response.advert_detail7.reverse().slice(0, 7);
        $scope.data = {
          totalBroadcastTimes: response.totalBroadcastTimes,
          totalAdvertisement: response.totalAdvertisement,
          totalAdvertiser: response.totalAdvertiser,
          totalUser: response.totalUser,
          lastDayBroadcast: last[0].totalBroadcastTimes,
          rate: (last[0].totalBroadcastTimes - last[1].totalBroadcastTimes) / last[0].totalBroadcastTimes
        };
        // 广告排放量前三
        var advert_most = [];
        for (var i = 0; i < response.advert_most.length; i++) {
          for (var j = i + 1; j < response.advert_most.length; j++) {
            if (response.advert_most[j].broadcastSum > response.advert_most[i].broadcastSum) {
              var temp = response.advert_most[i];
              response.advert_most[i] = response.advert_most[j];
              response.advert_most[j] = temp;
            }
          }
        }
        for (var i = 0; i < response.advert_most.length; i++) {
          response.advert_most[i].rank = 'Top' + (i + 1);
        }

        // 最近一周广告投放和最近一周收入统计
        var weekData = response.advert_detail7.reverse().slice(0, 7);
        var day = ['Sun', 'Mon', 'Tue', 'Web', 'Thu', 'Fri', 'Sat'];
        for (var i = 0; i < weekData.length; i++) {
          weekData[i].week = day[(new Date(weekData[i].date).getDay())];
        }
        // $scope.data = {
        //   lastDayBroadcast: weekData[0].totalBroadcastTimes,
        //   rate: (weekData[0].totalBroadcastTimes - weekData[1].totalBroadcastTimes) / weekData[0].totalBroadcastTimes
        // }
        // if (weekData[1].totalBroadcastTimes) {
        //   $scope.data = {
        //     rate: (weekData[0].totalBroadcastTimes - weekData[1].totalBroadcastTimes) / weekData[0].totalBroadcastTimes
        //   }
        // }
        weekData.reverse();

        //第二排第三个图
        var chart_week_income = AmCharts.makeChart("mob-desktop", {
          "type": "serial",
          "theme": "light",
          "dataProvider": weekData,
          "valueAxes": [ {
            "gridColor": "#FFFFFF",
            "gridAlpha": 0.2,
            "dashLength": 0
          } ],
          "gridAboveGraphs": true,
          "startDuration": 1,
          "graphs": [ {
            "balloonText": "[[date]]</br>[[category]]: <b>[[value]]</b>",
            "fillAlphas": 0.8,
            "lineAlpha": 0.2,
            "type": "column",
            "valueField": "totalIncome"
          } ],
          "chartCursor": {
            "categoryBalloonEnabled": false,
            "cursorAlpha": 0,
            "zoomable": false
          },
          "categoryField": "week",
          "categoryAxis": {
            "gridPosition": "start",
            "gridAlpha": 0,
            "tickPosition": "start",
            "tickLength": 0,
            "dashLength":0
          },
          "export": {
            "enabled": true
          }

        })

        //第二排第二个图
        var chart_top_rank = AmCharts.makeChart( "mobVsDesk", {
          "type": "pie",
          "theme": "light",
          "dataProvider": response.advert_most,
          "titleField": "rank",
          "valueField": "broadcastSum",
          "labelRadius": 5,

          "radius": "46%",
          "innerRadius": "60%",
          "labelText": "[[title]]",
          "export": {
            "enabled": true
          }
        } );

        //第二排第一个图
        var chart_week_delivery = AmCharts.makeChart("area-chart", {
          "type": "serial",
          "theme": "light",
          "marginRight": 30,
          "marginLeft": 50,
          "autoMarginOffset": 10,
          "mouseWheelZoomEnabled":true,
          // "dataDateFormat": "YYYY-MM-DD",
          "valueAxes": [{
            "id": "v1",
            "axisAlpha": 0,
            "position": "left",
            "ignoreAxisWidth":true
          }],
          "balloon": {
            "borderThickness": 1,
            "shadowAlpha": 0
          },
          "graphs": [{
            "id": "g1",
            "balloon":{
              "drop":true,
              "adjustBorderColor":false,
              "color":"#ffffff"
            },
            "bullet": "round",
            "bulletBorderAlpha": 1,
            "bulletColor": "#FFFFFF",
            "bulletSize": 5,
            "hideBulletsCount": 50,
            "useLineColorForBulletBorder": true,

            "lineThickness": 2,
            "title": "red line",
            "valueField": "totalBroadcastTimes",
            "balloonText": "[[date]]</br><span style='font-size:18px;'>[[value]]</span>"
          }],

          "chartCursor": {
            "pan": true,
            "valueLineEnabled": true,
            "valueLineBalloonEnabled": true,
            "cursorAlpha":1,
            "cursorColor":"#258cbb",
            "limitToGraph":"g1",
            "valueLineAlpha":0.2
          },

          "categoryField": "week",
          "categoryAxis": {
            "dashLength": 1,
            "minorGridEnabled": true
          },
          "export": {
            "enabled": true
          },
          "dataProvider": weekData
        });

        //第三排download图
        var chart = AmCharts.makeChart( "downloadChart", {
          "type": "serial",
          "theme": "default",
          "dataProvider": [ {
            "date": "3-6",
            "value": 2025
          }, {
            "date": "3-13",
            "value": 1882
          }, {
            "date": "3-20",
            "value": 1809
          }, {
            "date": "3-27",
            "value": 1322
          }, {
            "date": "4-3",
            "value": 1122
          }, {
            "date": "4-10",
            "value": 1114
          }, {
            "date": "4-13",
            "value": 584
          } ],
          "valueAxes": [ {
            "gridColor": "#FFFFFF",
            "gridAlpha": 0.2,
            "dashLength": 0
          } ],
          "gridAboveGraphs": true,
          "startDuration": 1,
          "graphs": [ {
            "balloonText": "[[category]]: <b>[[value]]</b>",
            "fillAlphas": 0.8,
            "lineAlpha": 0.2,
            "type": "column",
            "valueField": "value"
          } ],
          "chartCursor": {
            "categoryBalloonEnabled": false,
            "cursorAlpha": 0,
            "zoomable": false
          },
          "categoryField": "date",
          "categoryAxis": {
            "gridPosition": "start",
            "gridAlpha": 0,
            "tickPosition": "start",
            "tickLength": 0
          },
          "export": {
            "enabled": true
          }

        } );



        chart_week_delivery.addListener("rendered", zoomChart);

        zoomChart();

        function zoomChart() {
          chart_week_delivery.zoomToIndexes(chart.dataProvider.length - 40, chart.dataProvider.length - 1);
        }

      },
      function (error) {
        console.log(error);
      }
    )

  }
})();

(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .controller('backgroundManagementCtrl', backgroundManagementCtrl)
    .directive('edit', edit)
    .directive('update', ['UpdateLevelSrv', update])
    .directive('cancel', cancel);

  /** @ngInject */
  function backgroundManagementCtrl($scope, $state, BackUserListSrv, AddBackUserSrv, UpdateLevelSrv, TokenSrv, NoticeSrv, ErrorSrv) {
    $scope.copy = null;

    BackUserListSrv.getBackUserInfo().get()
    .$promise.then(
      function (response) {
        for (var user in response.backUserList) {
          if (response.backUserList[user].level == 1) {
            response.backUserList[user].levelTrans = '超级管理员';
          } else {
            response.backUserList[user].levelTrans = '普通管理员';
          }
        }
        $scope.currentPage = 1
        ,$scope.numPerPage = 5
        ,$scope.maxSize = 5
        ,$scope.length = response.backUserList.length;

        $scope.$watch("currentPage + numPerPage", function() {
          var begin = (($scope.currentPage - 1) * $scope.numPerPage)
          , end = begin + $scope.numPerPage;
          // console.log(begin + ' | ' + end);
          $scope.userList = response.backUserList.slice(begin, end);
        });
        // $scope.userList = response.backUserList;
      }, function (error) {
        console.log(error);
      }
    )

    $scope.addUser = function (name, email, gender, level, hireDate) {
      if (!name && email && gender && level && hireDate) {
        NoticeSrv.error(ErrorSrv.getError('410'));
      }
      if (name && !email && gender && level && hireDate) {
        NoticeSrv.error(ErrorSrv.getError('411'));
      }
      if (name && email && !gender && level && hireDate) {
        NoticeSrv.error(ErrorSrv.getError('412'));
      }
      if (name && email && gender && !level && hireDate) {
        NoticeSrv.error(ErrorSrv.getError('413'));
      }
      if (name && email && gender && level && !hireDate) {
        NoticeSrv.error(ErrorSrv.getError('414'));
      }
      else if (name && email && gender && level && hireDate){
        AddBackUserSrv.addBackUser().save({
          userName: name,
          email: email,
          gender: gender,
          level: level,
          hireDate: hireDate
        }).$promise.then(
          function (response) {
            NoticeSrv.success("添加管理员成功成功");
            $state.go('app.admin-userlist');
          }, function (error) {
            NoticeSrv.notice("操作失败");
            console.log(error);
          }
        )
      }
      else {
        NoticeSrv.error(ErrorSrv.getError('415'));
      }
    }

  }

  function edit() {
    return {
      restrict: 'AE',
      require: 'ngModel',
      link: function (scope, element, attrs, ngModel) {
        element.bind("click", function() {
          var id = "level_" + ngModel.$modelValue.id;
            scope.copy = angular.copy(ngModel.$modelValue.level);
            // console.log(ngModel.$modelValue.level + ' : ' + scope.copy);
            var obj = $("#"+id);
            obj.removeClass("inactive");
            obj.addClass("active");
            obj.removeAttr("readOnly");
            scope.$apply(function(){
              scope.showEdit = true;
              scope.showUpdate = true;
              scope.showCancel = true;
              scope.display = true;
              scope.editDisplay = true;
            })
          });
      }
    }
  }

  function update(UpdateLevelSrv) {
    return{
      restrict: 'AE',
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel){
        element.bind("click",function(){
          var id = "level_" + ngModel.$modelValue.id;
          // console.log('id: ' + ngModel.$modelValue.id);
          // console.log('newLevel: ' + ngModel.$modelValue.newLevel);
          UpdateLevelSrv.updateAdminLevel().save({
            id: ngModel.$modelValue.id,
            newLevel: ngModel.$modelValue.newLevel
          }).$promise.then(
            function (response) {
              console.log(response.errCode);
            }, function (error) {
              console.log(error);
            }
          )
          var obj = $("#"+id);
          obj.removeClass("active");
          obj.addClass("inactive");
          obj.attr("readOnly",true);
          scope.$apply(function(){
            scope.showEdit = false;
            scope.showUpdate = false;
            scope.showCancel = false;
            scope.display = false;
            scope.editDisplay = false;
          })
        })
      }
    }
  }

  function cancel() {
    return{
      restrict: 'AE',
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel){
        element.bind("click",function(){
          scope.$apply(function(){
            ngModel.$modelValue.level = scope.copy;
            //console.log(ngModel.$modelValue);
          });

          var id = "level_" + ngModel.$modelValue.id;
          var obj = $("#"+id);
          obj.removeClass("active");
          obj.addClass("inactive");
          obj.prop("readOnly",true);
          scope.$apply(function(){
            scope.showEdit = false;
            scope.showUpdate = false;
            scope.showCancel = false;
            scope.display = false;
            scope.editDisplay = false;
          })
        })
      }
    }
  }
})();




/**
 * Created by mandyxue on 16/4/5.
 */

(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .controller('AdvertSearchCtrl', AdvertSearchCtrl);

  /** @ngInject */
  function AdvertSearchCtrl($scope, $rootScope, $state, searchAdsSrv, adDetailSrv) {

    $scope.places = ['','嘉定区','金山区','奉贤区','松江区','青浦区','闵行区','浦东新区','长宁区','黄浦区','宝山区','虹口区','杨浦区','崇明县','徐汇区','静安区','普陀区'];
    $scope.selectedPlace = $scope.places[0];

  	$scope.search = function(id, title, selectedPlace, startDate, endDate) {
      var location = '';
  		if(startDate){
  			var start = moment(startDate).format("YYYY-MM-DD 00:00:00");
  		}
  		if(endDate){
  			var end = moment(endDate).format("YYYY-MM-DD 00:00:00");
  		}
      for (var i = 1; i < $scope.places.length; i++) {
      if(selectedPlace == $scope.places[i]){
        if(i < 10) location = '00' + i;
        else location = '0' + i;
        break;
      }else{
        location = '';
      }

    };

    console.log(location);
  		searchAdsSrv.searchAds().save({},{
  			id: id,
  			title: title,
  			broadcastLocation: location,
  			startDate: start,
  			endDate: end
  		}).$promise.then(
     	 function (response) {
        	// console.log(response);
       	    if(response.errCode == 0){
            //alert("操作成功");
            //window.location.reload();

            //console.log(response.resultList[0].status);
            for (var i = 0; i < response.resultList.length; i++) {
            if(response.resultList[i].status == "000") response.resultList[i].status ="未通过审核";
            else if(response.resultList[i].status == "001") response.resultList[i].status ="已通过审核";
            else if(response.resultList[i].status == "010") response.resultList[i].status ="草稿";
            else if(response.resultList[i].status == "100") response.resultList[i].status ="未审核";
            else if(response.resultList[i].status == "101") response.resultList[i].status ="已下架";

          }
            $scope.resultList = response.resultList;

            // 分页
            $scope.currentPage = 1
            ,$scope.numPerPage = 5
            ,$scope.maxSize = 5
            ,$scope.length = response.resultList.length;

            $scope.$watch("currentPage + numPerPage", function() {
              var begin = (($scope.currentPage - 1) * $scope.numPerPage)
              , end = begin + $scope.numPerPage;
              // console.log(begin + ' | ' + end);
              $scope.resultList = response.resultList.slice(begin, end);
            });

            // $scope.resultList = response.resultList;

        }else{
          alert("操作失败");
          //window.location.reload();
       	 };
      	}, function (error) {
        console.log(error);
      }
    );
  }

//显示广告详情，投放商圈没有处理，因为数据格式不确定
  $scope.adsDetail = function(id) {
  	//$state.go('app.advert-detail');
   	console.log(id);
   	$rootScope.ad_id = id;
   	//var broadcastLocation = {}；

   	adDetailSrv.getAdDetail().save({},{
   		//token: token,
   		id: id
   	}).$promise.then(
   	function (response){
   		console.log(response.adsDetail);
   		$rootScope.ad_title = response.adsDetail.title;
   		$rootScope.ad_content = response.adsDetail.content;
   		$rootScope.ad_catalog = response.adsDetail.catalog;
   		$rootScope.ad_startDate = response.adsDetail.startDate;
   		$rootScope.ad_endDate = response.adsDetail.endDate;
      var location = response.adsDetail.broadcastLocation;
      console.log(location.length);
      var showLocation = "";
      for (var i = 0; i < location.length; i++) {
        if(location[i] == "001"){
          showLocation = showLocation + "嘉定区 ";
        }else if(location[i] == "002"){
          showLocation = showLocation + "金山区 ";
        }else if(location[i] == "003"){
          showLocation = showLocation + "奉贤区 ";
        }else if(location[i] == "004"){
          showLocation = showLocation + "松江区 ";
        }else if(location[i] == "005"){
          showLocation = showLocation + "青浦区 ";
        }else if(location[i] == "006"){
          showLocation = showLocation + "闵行区 ";
        }else if(location[i] == "007"){
          showLocation = showLocation + "浦东新区 ";
        }else if(location[i] == "008"){
          showLocation = showLocation + "长宁区 ";
        }else if(location[i] == "009"){
          showLocation = showLocation + "黄浦区 ";
        }else if(location[i] == "010"){
          showLocation = showLocation + "宝山区 ";
        }else if(location[i] == "011"){
          showLocation = showLocation + "虹口区 ";
        }else if(location[i] == "012"){
          showLocation = showLocation + "杨浦区 ";
        }else if(location[i] == "013"){
          showLocation = showLocation + "崇明县 ";
        }else if(location[i] == "014"){
          showLocation = showLocation + "徐汇区 ";
        }else if(location[i] == "015"){
          showLocation = showLocation + "静安区 ";
        }else if(location[i] == "016"){
          showLocation = showLocation + "普陀区 ";
        }
      };
      $rootScope.broadcastLocation = showLocation;
   		//$rootScope.broadcastLocation = response.adsDetail.broadcastLocation;

   	}, function (error) {
   		console.log(error);
   	});
  }



 }
})();

/**
 * Created by mandyxue on 16/4/5.
 */
(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .controller('AdvertPushCtrl', AdvertPushCtrl);

  /** @ngInject */
  function AdvertPushCtrl() {

  }
})();

/**
 * Created by mandyxue on 16/4/5.
 */

(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .directive('mymodal', mymodal)
    .directive('mymodal1', mymodal1)
    .controller('AdvertDetailCtrl', AdvertDetailCtrl);

  /** @ngInject */
  function AdvertDetailCtrl($scope, $state, auditAdsSrv, adDetailSrv, NoticeSrv) {
    //审核广告，根据tag=1或0来区别通过与不通过
    var reason = '';
  	$scope.audit = function(id, tag, reason){
      if (tag == 0) {
        reason = reason;
      }
      adDetailSrv.getAdDetail().save({
        id: id
      }).$promise.then(
        function (response) {
          auditAdsSrv.auditAds().save({},{
        		id: id,
        		success: tag,
            title: response.adsDetail.title,
            reason: reason
        	}).$promise.then(
            function (response) {
              // console.log(response);
              if(response.errCode == 0){
                NoticeSrv.success("操作成功");

                // alert("操作成功");
                // window.location.reload();
              }else{
                NoticeSrv.error("操作失败");
                // alert("操作失败");
                // window.location.reload();
              };
            }, function (error) {
              console.log(error);
            }
          );
        }, function (err) {
          console.log(err);
        }
      )
      if(tag == 1){
        $state.go('app.advert-audit');
        window.location.reload();
      }
  	};

    //下架广告，蒙版问题还没有解决，暂时没有跳转，只是刷新本页
  	$scope.remove = function(id,reason){
      adDetailSrv.getAdDetail().save({
        id: id
      }).$promise.then(
        function (response) {
        	auditAdsSrv.removeAds().save({},{
        		id: id,
            title: response.adsDetail.title,
        		reason: reason
        	}).$promise.then(
            function (response) {
              console.log(response);
              //$('#myModal').modal('hide');
              // $state.go('app.advert-audit');
              if(response.errCode == 0){
                alert("操作成功");
                // window.location.reload();
                // $state.go('app.advert-audit');
              }else{
                alert("操作失败");
                // window.location.reload();
              };
            }, function (error) {
              console.log(error);
            }
          );
        }, function(err) {
          console.log(err);
        }
      )
    }
  }

  function mymodal ($location, $state) {
    return {
      restrict: 'AE',
      require: 'ngModel',
      link: function (scope, element, attrs, ngModel) {
        element.bind("click", function() {
          var obj = $("#exampleModal");
          obj.modal('hide');
          setTimeout(function() {
            $state.go('app.advert-audit');
          }, 1000);
          scope.$apply(function(){
            // scope.back = true;
            scope.pass = true;
            scope.remove = false;
            scope.notPass = true;
          })
        });
      }
    }
  }

  function mymodal1 ($location, $state) {
    return {
      restrict: 'AE',
      require: 'ngModel',
      link: function (scope, element, attrs, ngModel) {
        element.bind("click", function() {
          var obj = $("#myModal");
          obj.modal('hide');
          setTimeout(function() {
            $state.go('app.advert-audit');
          }, 1000);
          scope.$apply(function(){
            // scope.back = true;
            scope.pass = true;
            scope.remove = false;
            scope.notPass = true;
          })
        });
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('madBackWeb')
    .controller('AdminInfoCtrl', AdminInfoCtrl);

    function AdminInfoCtrl ($window, $rootScope, $scope, $state, BackUserListSrv, UpdateAdminInfoSrv, NoticeSrv, ErrorSrv) {
      BackUserListSrv.getBackUserInfo().get()
      .$promise.then(
        function (response) {
          for (var user in response.backUserList) {
            if (response.backUserList[user].id == $window.localStorage['adminId']) {
              if (response.backUserList[user].level == 1) {
                $scope.admin = {
                  id: response.backUserList[user].id,
                  name: response.backUserList[user].name,
                  email: response.backUserList[user].email,
                  levelT: '超级管理员'
                };
              } else {
                $scope.admin = {
                  id: response.backUserList[user].id,
                  name: response.backUserList[user].name,
                  email: response.backUserList[user].email,
                  levelT: '普通管理员'
                };
              }
              $rootScope.id = response.backUserList[user].id;
              $rootScope.email = response.backUserList[user].email;
            }
          }
        }, function (error) {
          console.log(error);
        }
      )
      $scope.updateAdminInfo = function (password, confirmPass) {
        if (!password || !confirmPass) {
          NoticeSrv.error(ErrorSrv.getError('416'));
        }
        if (password && confirmPass && (password === confirmPass)) {
          if (password.length<8) {
            NoticeSrv.error(ErrorSrv.getError('419'));
            $state.go('app.admin-info');
          }
          else {
            // console.log($rootScope.id, $rootScope.email, password)
            UpdateAdminInfoSrv.updateAdminInfo().save({
              id: $rootScope.id,
              email: $rootScope.email,
              password: password
            }).$promise.then(
              function (response) {
                NoticeSrv.error(ErrorSrv.getError('418'));
                $state.go('app.login');
              },
              function (error) {
                console.log(error);
              }
            )
          }
        }
        if (password && confirmPass && (password !== confirmPass)) {
          NoticeSrv.error(ErrorSrv.getError('417'));
          $state.go('app.admin-info');
        }
      }
    }
})();

/**
 * Created by mandyxue on 16/4/5.
 */
(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .controller('AdvertAuditCtrl', AdvertAuditCtrl);

  /** @ngInject */
  function AdvertAuditCtrl($scope, $state, adsListSrv, adDetailSrv, $rootScope) {
  	var token = "";
  	adsListSrv.getNotAuditList().save({},{
  		//token: token,
  		tag: 1
  	}).$promise.then(
      function (response) {
      	//console.log(response.notAuditAdsList);
        // 分页
        $scope.currentPage = 1
        ,$scope.numPerPage = 5
        ,$scope.maxSize = 5
        ,$scope.length = response.notAuditAdsList.length;

        $scope.$watch("currentPage + numPerPage", function() {
          var begin = (($scope.currentPage - 1) * $scope.numPerPage)
          , end = begin + $scope.numPerPage;
          // console.log(begin + ' | ' + end);
          $scope.advertList = response.notAuditAdsList.slice(begin, end);
        });
        // $scope.advertList = response.notAuditAdsList;
      }, function (error) {
        console.log(error);
      }
    );


//显示广告详情，投放商圈没有处理，因为数据格式不确定
   $scope.adsDetail = function(id) {
   //	window.location.href='http://localhost:3000/#/advert/detail';
   	$state.go('app.advert-detail');
   	console.log(id);
   	$rootScope.ad_id = id;
   	//var broadcastLocation = {}；

   	adDetailSrv.getAdDetail().save({},{
   		//token: token,
   		id: id
   	}).$promise.then(
   	function (response){
   		console.log(response.adsDetail);
   		$rootScope.ad_title = response.adsDetail.title;
   		$rootScope.ad_content = response.adsDetail.content;
   		$rootScope.ad_catalog = response.adsDetail.catalog;
   		$rootScope.ad_startDate = response.adsDetail.startDate;
   		$rootScope.ad_endDate = response.adsDetail.endDate;
   		var location = response.adsDetail.broadcastLocation;
      console.log(location.length);
      var showLocation = "";
      for (var i = 0; i < location.length; i++) {
        if(location[i] == "001"){
          showLocation = showLocation + "嘉定区 ";
        }else if(location[i] == "002"){
          showLocation = showLocation + "金山区 ";
        }else if(location[i] == "003"){
          showLocation = showLocation + "奉贤区 ";
        }else if(location[i] == "004"){
          showLocation = showLocation + "松江区 ";
        }else if(location[i] == "005"){
          showLocation = showLocation + "青浦区 ";
        }else if(location[i] == "006"){
          showLocation = showLocation + "闵行区 ";
        }else if(location[i] == "007"){
          showLocation = showLocation + "浦东新区 ";
        }else if(location[i] == "008"){
          showLocation = showLocation + "长宁区 ";
        }else if(location[i] == "009"){
          showLocation = showLocation + "黄浦区 ";
        }else if(location[i] == "010"){
          showLocation = showLocation + "宝山区 ";
        }else if(location[i] == "011"){
          showLocation = showLocation + "虹口区 ";
        }else if(location[i] == "012"){
          showLocation = showLocation + "杨浦区 ";
        }else if(location[i] == "013"){
          showLocation = showLocation + "崇明县 ";
        }else if(location[i] == "014"){
          showLocation = showLocation + "徐汇区 ";
        }else if(location[i] == "015"){
          showLocation = showLocation + "静安区 ";
        }else if(location[i] == "016"){
          showLocation = showLocation + "普陀区 ";
        }
      };
   		$rootScope.broadcastLocation = showLocation;


   	}, function (error) {
   		console.log(error);
   	});
   }
}



})();

(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('app', {
        url: '/',
        views: {
            'header': {
                templateUrl: 'app/components/header/header.html',
                controller: 'HeaderCtrl'
            },
            'navbar': {
                templateUrl: 'app/components/navbar/navbar.html',
                controller: 'navbarCtrl'
            },
            'sub-navbar': {
                templateUrl: 'app/components/sub-navbar/dashboard-sub-navbar.html',
                controller: 'subNavbarCtrl'
            },
            'content': {
                templateUrl: 'app/dashboard/dashboard.html',
                controller: 'MainController'
            },
            'footer': {
                templateUrl: 'app/components/footer/footer.html'
            }
        }
      })
      .state('app.login', {
        url: 'login',
        views: {
            'header@': {
                templateUrl: 'app/blank/blank.html'
            },
            'navbar@': {
                templateUrl: 'app/blank/blank.html',
                controller: 'navbarCtrl'
            },
            'sub-navbar@': {
                templateUrl: 'app/blank/blank.html',
                controller: 'subNavbarCtrl'
            },
            'content@': {
                templateUrl: 'app/login/login.html',
                controller: 'LoginCtrl'
            },
            'footer@': {
                templateUrl: 'app/blank/blank.html'
            }
        }
      })
      .state('app.admin-info', {
        url: 'admin-info',
        views: {
            'sub-navbar@': {
              templateUrl: 'app/components/sub-navbar/admin-info-sub-navbar.html',
              controller: 'subNavbarCtrl'
            },
            'content@': {
              templateUrl: 'app/admin-info/admin-info.html',
              controller: 'AdminInfoCtrl'
            }
        }
      })
      .state('app.advert-push', {
        url: 'advert/push',
        views: {
            'sub-navbar@': {
              templateUrl: 'app/components/sub-navbar/advert-sub-navbar.html',
              controller: 'subNavbarCtrl'
            },
            'content@': {
              templateUrl: 'app/advert-push/advert-push.html',
              controller: 'AdvertPushCtrl'
            }
        }
      })
      .state('app.advert-audit', {
        url: 'advert/audit',
        views: {
          'sub-navbar@': {
            templateUrl: 'app/components/sub-navbar/advert-sub-navbar.html',
            controller: 'subNavbarCtrl'
          },
          'content@': {
            templateUrl: 'app/advert-audit/advert-audit.html',
            controller: 'AdvertAuditCtrl'
          }
        }
      })
      .state('app.advert-search', {
        url: 'advert/search',
        views: {
          'sub-navbar@': {
            templateUrl: 'app/components/sub-navbar/advert-sub-navbar.html',
            controller: 'subNavbarCtrl'
          },
          'content@': {
            templateUrl: 'app/advert-search/advert-search.html',
            controller: 'AdvertSearchCtrl'
          }
        }
      })
      .state('app.user', {
        url: 'user/list-mobile',
        views: {
            'sub-navbar@': {
                templateUrl: 'app/components/sub-navbar/user-list-sub-navbar.html',
                controller: 'subNavbarCtrl'
            },
            'content@': {
                templateUrl: 'app/user-list-mobile/user-list-mobile.html',
                controller: 'UserListCtrl'
            }
        }
      })
      .state('app.user.list-advert', {
        url: 'user/list-advert',
        views: {
            'sub-navbar@': {
                templateUrl: 'app/components/sub-navbar/user-list-sub-navbar.html',
                controller: 'subNavbarCtrl'
            },
            'content@': {
                templateUrl: 'app/user-list-advert/user-list-advert.html',
                controller: 'AdvertListCtrl'
            }
        }
      })
      .state('app.user.check-advert', {
        url: 'user/check-advert',
        views: {
            'sub-navbar@': {
                templateUrl: 'app/components/sub-navbar/user-check-sub-navbar.html',
                controller: 'subNavbarCtrl'
            },
            'content@': {
                templateUrl: 'app/user-check-advert/user-check-advert.html',
                controller: 'UserCheckCtrl'
            }
        }
      })
      .state('app.user.check-mobile', {
          url: 'user/check-mobile',
          views: {
            'sub-navbar@': {
              templateUrl: 'app/components/sub-navbar/user-check-sub-navbar.html',
              controller: 'subNavbarCtrl'
            },
            'content@': {
              templateUrl: 'app/user-check-mobile/user-check-mobile.html',
              controller: 'UserCheckCtrl'
            }
          }
      })
      .state('app.user.create', {
          url: 'user/create',
          views: {
            'sub-navbar@': {
              templateUrl: 'app/components/sub-navbar/user-create-sub-navbar.html',
              controller: 'subNavbarCtrl'
            },
            'content@': {
              templateUrl: 'app/user-create/user-create.html'
            }
          }
      })
      .state('app.user.detail-advert', {
          url: 'user/detail-advert',
          views: {
            'sub-navbar@': {
              templateUrl: 'app/components/sub-navbar/user-detail-sub-navbar.html',
              controller: 'subNavbarCtrl'
            },
            'content@': {
              templateUrl: 'app/user-detail-advert/user-detail-advert.html',
              controller: 'AdvertListCtrl'
            }
          }
      })
      .state('app.user.detail-mobile', {
          url: 'user/detail-mobile',
          views: {
            'sub-navbar@': {
              templateUrl: 'app/components/sub-navbar/user-detail-sub-navbar.html',
              controller: 'subNavbarCtrl'
            },
            'content@': {
              templateUrl: 'app/user-detail-mobile/user-detail-mobile.html',
              controller: 'UserListCtrl'
            }
          }
      })
      .state('app.advert-detail', {
        url: 'advert/detail',
        views: {
          'sub-navbar@': {
            templateUrl: 'app/components/sub-navbar/advert-sub-navbar.html',
            controller: 'subNavbarCtrl'
          },
          'content@': {
            templateUrl: 'app/advert-detail/advert-detail.html',
            controller: 'AdvertDetailCtrl'
          }
        }
      })
      .state('app.admin-userlist', {
        url: 'admin/userlist',
        views: {
          'navbar@': {
            templateUrl: 'app/components/navbar/navbar.html',
            controller: 'navbarCtrl'
          },
          'sub-navbar@': {
            templateUrl: 'app/components/sub-navbar/back-userlist-sub-navbar.html',
            controller: 'subNavbarCtrl'
          },
          'content@': {
            templateUrl: 'app/back-userlist/back-userlist.html',
            controller: 'backgroundManagementCtrl'
          }
        }
      })
      .state('app.admin-adduser', {
        url: 'admin/adduser',
        views: {
          'navbar@': {
            templateUrl: 'app/components/navbar/navbar.html',
            controller: 'navbarCtrl'
          },
          'sub-navbar@': {
            templateUrl: 'app/components/sub-navbar/back-userlist-sub-navbar.html',
            controller: 'subNavbarCtrl'
          },
          'content@': {
            templateUrl: 'app/back-adduser/back-adduser.html',
            controller: 'backgroundManagementCtrl'
          }
        }
      })
      .state('app.admin-auth', {
        url: 'admin/auth',
        views: {
          'navbar@': {
            templateUrl: 'app/components/navbar/navbar.html',
            controller: 'navbarCtrl'
          },
          'sub-navbar@': {
            templateUrl: 'app/components/sub-navbar/back-userlist-sub-navbar.html',
            controller: 'subNavbarCtrl'
          },
          'content@': {
            templateUrl: 'app/back-auth/back-auth.html',
            controller: 'backgroundManagementCtrl'
          }
        }
      })
      .state('app.statistics', {
        url: 'statistics',
        views: {
          'sub-navbar@': {
            templateUrl: 'app/components/sub-navbar/statistics-sub-navbar.html',
            controller: 'subNavbarCtrl'
          },
          'content@': {
            templateUrl: 'app/statistics/statistics.html',
            controller: 'StatisticsCtrl'
          }
        }
      })
      .state('app.finance', {
        url: 'finance',
        views: {
          'sub-navbar@': {
            templateUrl: 'app/components/sub-navbar/finance-sub-navbar.html',
            controller: 'subNavbarCtrl'
          },
          'content@': {
            templateUrl: 'app/finance/finance.html',
            controller: 'FinanceDetailCtrl'
          }
        }
      })
      .state('app.finance.cash', {
        url: '/cash',
        views: {
          'content@': {
            templateUrl: 'app/finance-cash/finance-cash.html',
            controller: 'cashApplyCtrl'
          }
        }
      })
      .state('app.finance.recharge', {
        url: '/recharge',
        views: {
          'content@': {
            templateUrl: 'app/finance-recharge/finance-recharge.html',
            controller: 'rechargeApplyCtrl'
          }
        }
      })
      .state('app.finance.refund', {
        url: '/refund',
        views: {
          'content@': {
            templateUrl: 'app/finance-refund/finance-refund.html',
            controller: 'refundApplyCtrl'
          }
        }
      })
      .state('app.advert-upload', {
        url: 'advert/upload',
        views: {
          'sub-navbar@': {
              templateUrl: 'app/components/sub-navbar/advert-sub-navbar.html',
              controller: 'subNavbarCtrl'
          },
          'content@': {
            templateUrl: 'app/upload/upload.html',
            controller: 'UploadCtrl'
          }
        }
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('madBackWeb')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';
  angular
    .module('madBackWeb')
    .config(config);

  /** @ngInject */
  function config($httpProvider, $logProvider, toastrConfig) {
    $httpProvider.interceptors.push('myInterceptor');
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

  angular.module('madBackWeb').value('baseURL', 'http://121.42.57.59:4000/back');
})();

angular.module("madBackWeb").run(["$templateCache", function($templateCache) {$templateCache.put("app/admin-info/admin-info.html","<div class=\"dashboard-wrapper\"><div class=\"left-sidebar col-md-offset-2\"><div class=\"row\"><div class=\"col-lg-12 col-md-12\"><div class=\"widget no-margin\"><div class=\"widget-header\"><div class=\"title\">Edit Profile</div><span class=\"tools\"><i class=\"fa fa-cogs\"></i></span></div><div class=\"widget-body\"><div class=\"row\"><div class=\"col-lg-3 col-md-4 col-sm-12 col-xs-12\"><div class=\"thumbnail\"><img alt=\"300x200\" src=\"assets/images/profile.png\"><br><h4 class=\"center-align-text\">{{admin.name}}</h4><h4 class=\"center-align-text\">{{admin.levelT}}</h4><p class=\"center-align-text\">MAD平台管理员</p></div><br></div><div class=\"col-lg-9 col-md-8 col-sm-12 col-xs-12\"><form class=\"form-horizontal\"><h5>Login Information</h5><hr><div class=\"form-group\"><label for=\"emailId\" class=\"col-sm-3 control-label\">ID</label><div class=\"col-sm-9\"><label class=\"form-control\">{{admin.id}}</label></div></div><div class=\"form-group\"><label for=\"emailId\" class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><label class=\"form-control\">{{admin.email}}</label></div></div><div class=\"form-group\"><label for=\"inputPassword\" class=\"col-sm-3 control-label\">Reset Password</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"inputPassword\" placeholder=\"New Password\" ng-model=\"password\"></div></div><div class=\"form-group\"><label for=\"inputPassword1\" class=\"col-sm-3 control-label\">Confirm Password</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"inputPassword1\" placeholder=\"Confirm Password\" ng-model=\"confirmPass\"></div></div><div class=\"form-actions\"><button type=\"submit\" class=\"btn btn-info pull-right\" ng-click=\"updateAdminInfo(password, confirmPass)\">Save changes</button></div></form></div></div></div></div></div></div></div></div>");
$templateCache.put("app/advert-audit/advert-audit.html","<div class=\"dashboard-wrapper-lg\"><div class=\"row\"><div class=\"col-lg-12 col-md-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">未审核广告</div></div><div class=\"widget-body\"><table class=\"table table-responsive table-striped table-bordered table-hover no-margin\"><thead><tr><th>广告编号</th><th>广告标题</th><th>广告类别</th><th>申请人</th><th>查看详情/审核</th></tr></thead><tbody><tr ng-repeat=\"advert in advertList\"><td>{{advert.id}}</td><td>{{advert.title}}</td><td><span class=\"label label-info\">{{advert.catalog}}</span></td><td>{{advert.belongTo}}</td><td class=\"hidden-xs\"><button class=\"btn btn-warning btn-xs\" ng-click=\"adsDetail(advert.id)\">查看详情/审核</button></td></tr></tbody></table><pagination ng-model=\"currentPage\" total-items=\"length\" items-per-page=\"numPerPage\" max-size=\"maxSize\" boundary-links=\"true\"></pagination></div></div></div></div></div>");
$templateCache.put("app/advert-detail/advert-detail.html","<div class=\"dashboard-wrapper-lg\"><div class=\"row\"><div class=\"col-lg-8 col-lg-offset-2 col-md-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">香水广告(广告名称) <span class=\"mini-title\">详细信息</span></div></div><div class=\"widget-body\"><form class=\"form-horizontal no-margin\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">广告编号</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" value=\"{{ad_id}}\" disabled=\"\"></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">广告标题</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" value=\"{{ad_title}}\" disabled=\"\"></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">广告内容</label><div class=\"col-sm-10\"><textarea type=\"text\" class=\"form-control\" disabled=\"\">{{ad_content}}</textarea></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">广告类别</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" value=\"{{ad_catalog}}\" disabled=\"\"></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 col-xs-12 control-label\">投放商圈</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" value=\"{{broadcastLocation}}\" disabled=\"\"></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">广告投放起始日期</label><div class=\"col-sm-10\"><input class=\"form-control\" value=\"{{ad_startDate}}\" disabled=\"\"></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">广告投放结束日期</label><div class=\"col-sm-10\"><input class=\"form-control\" value=\"{{ad_endDate}}\" disabled=\"\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-success btn-advert\" ng-click=\"audit(ad_id, 1)\" ng-show=\"!pass\">审核通过</button> <button type=\"submit\" class=\"btn btn-danger btn-advert\" data-toggle=\"modal\" data-target=\"#myModal\" ng-show=\"!notPass\">审核不通过</button><button type=\"submit\" class=\"btn btn-danger btn-advert\" data-toggle=\"modal\" data-target=\"#exampleModal\" ng-show=\"remove\">下架</button></div></div></form></div></div></div></div></div><div class=\"modal fade\" id=\"exampleModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">下架理由</h4></div><div class=\"modal-body\"><textarea style=\"width: 100%\" ng-model=\"reason\"></textarea></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">取消</button><mymodal ng-model=\"advert\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"remove(ad_id,reason)\">确定</button></mymodal></div></div></div></div><div class=\"modal fade\" id=\"myModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">审核不通过理由</h4></div><div class=\"modal-body\"><textarea style=\"width: 100%\" ng-model=\"reasonNotPass\"></textarea></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">取消</button><mymodal1 ng-model=\"advert\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"audit(ad_id, 0, reasonNotPass)\">确定</button></mymodal1></div></div></div></div>");
$templateCache.put("app/advert-push/advert-push.html","<div class=\"dashboard-wrapper-lg\"><div class=\"row\"><div class=\"col-lg-8 col-lg-offset-2 col-md-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">发布新广告 <span class=\"mini-title\">填入新广告的信息</span></div></div><div class=\"widget-body\"><form class=\"form-horizontal no-margin\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">广告编号</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" placeholder=\"自动生成\" value=\"\" disabled=\"\"></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">广告标题</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" placeholder=\"输入广告的标题\"></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">广告内容</label><div class=\"col-sm-10\"><textarea type=\"text\" class=\"form-control\" placeholder=\"输入广告内容\"></textarea></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">广告类别</label><div class=\"col-sm-10\"><select class=\"form-control\"><option>- 请选择 -</option><option value=\"\">普通广告</option><option value=\"\">公益广告</option></select></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 col-xs-12 control-label\">投放商圈</label><div class=\"checkbox col-sm-10 col-xs-8\"><label><input type=\"checkbox\" value=\"\" checked=\"\">五角场</label> <label><input type=\"checkbox\" value=\"\" checked=\"\">人民广场</label> <label><input type=\"checkbox\" value=\"\" checked=\"\">徐家汇</label> <label><input type=\"checkbox\" value=\"\" checked=\"\">静安寺</label> <label><input type=\"checkbox\" value=\"\" checked=\"\">陆家嘴</label> <label><input type=\"checkbox\" value=\"\" checked=\"\">世纪公园</label> <label><input type=\"checkbox\" value=\"\">中山公园</label> <label><input type=\"checkbox\" value=\"\">张江</label> <label><input type=\"checkbox\" value=\"\">南京东路</label> <label><input type=\"checkbox\" value=\"\">虹桥</label> <label><input type=\"checkbox\" value=\"\">浦东机场</label></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">广告投放起始日期</label><div class=\"col-sm-10\"><input type=\"date\" class=\"form-control\" required=\"\"></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">广告投放结束日期</label><div class=\"col-sm-10\"><input type=\"date\" class=\"form-control\" required=\"\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-success btn-advert\">完成</button> <button type=\"submit\" class=\"btn btn-danger btn-advert\">取消</button> <button type=\"submit\" class=\"btn btn-info btn-advert\">暂存</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/advert-search/advert-search.html","<div class=\"dashboard-wrapper-lg\"><div class=\"row\"><div class=\"col-lg-12 col-md-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">广告查询</div></div><div class=\"widget-body\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"panel panel-info\"><div class=\"panel-heading\">广告筛选条件</div><div class=\"panel-body\"><form><div class=\"form-group\"><label for=\"\">广告编号</label> <input type=\"text\" class=\"form-control\" placeholder=\"输入广告编号\" ng-model=\"id\"></div><div class=\"form-group\"><label for=\"\">广告标题</label> <input type=\"text\" class=\"form-control\" placeholder=\"输入广告标题\" ng-model=\"title\"></div><div class=\"form-group\"><label for=\"\">广告投放地点</label><select ng-model=\"selectedPlace\" class=\"form-control\" ng-options=\"place for place in places\"></select></div><div class=\"form-group\"><label for=\"\">播放起始日期</label> <input id=\"myDate\" type=\"date\" class=\"form-control\" ng-model=\"startDate\"></div><div class=\"form-group\"><label for=\"\">播放结束日期</label> <input type=\"date\" class=\"form-control\" ng-model=\"endDate\"></div><div class=\"text-center\"><button class=\"btn btn-success\" style=\"width:80%;\" ng-click=\"search(id,title,selectedPlace,startDate,endDate)\">查询</button></div></form></div></div></div><div class=\"col-md-9\"><h4 class=\"text-center\">查询结果</h4><hr><table class=\"table table-responsive table-striped table-bordered table-hover no-margin\"><thead><tr><th>广告编号</th><th>广告标题</th><th>广告类别</th><th>申请人(所属人)</th><th>广告状态</th><th>编辑</th></tr></thead><tbody><tr ng-repeat=\"item in resultList\"><td>{{item.adId}}</td><td>{{item.title}}</td><td class=\"ordinary-advert\">{{item.catalog}}</td><td>{{item.advertiser}}</td><td><span class=\"label label-success\">{{item.status}}</span></td><td class=\"hidden-xs\"><div class=\"dropdown\"><button class=\"dropdown-toggle btn btn-info btn-xs\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">操作 <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li><a ui-sref=\"app.advert-detail\" ng-click=\"adsDetail(item.adId)\">查看详情</a></li></ul></div></td></tr></tbody></table><pagination ng-model=\"currentPage\" total-items=\"length\" items-per-page=\"numPerPage\" max-size=\"maxSize\" boundary-links=\"true\"></pagination></div></div></div></div></div></div></div>");
$templateCache.put("app/back-adduser/back-adduser.html","<div class=\"dashboard-wrapper-lg\"><div class=\"row\"><div class=\"col-md-offset-2 col-md-8\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">添加管理员</div></div><div class=\"widget-body\"><form class=\"form-horizontal no-margin\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">姓名</label><div class=\"col-md-8\"><input type=\"text\" class=\"form-control\" id=\"inputName\" placeholder=\"Name\" ng-model=\"name\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">邮箱</label><div class=\"col-md-8\"><input type=\"email\" class=\"form-control\" id=\"inputEmail\" placeholder=\"Email\" ng-model=\"email\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">性别</label><div class=\"col-md-8\"><label class=\"radio-inline\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"inlineRadio1\" value=\"male\" ng-model=\"gender\"> 男</label> <label class=\"radio-inline\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"inlineRadio2\" value=\"female\" ng-model=\"gender\"> 女</label></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">权限级别</label><div class=\"col-md-4\"><label class=\"radio-inline\"><input type=\"radio\" name=\"super-admin\" value=\"1\" ng-model=\"level\">超级管理员</label> <label class=\"radio-inline\"><input type=\"radio\" name=\"normal-admin\" value=\"2\" ng-model=\"level\">普通管理员</label></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">入职时间</label><div class=\"col-md-4\"><input type=\"date\" class=\"form-control\" id=\"inputDate\" placeholder=\"Date\" ng-model=\"hireDate\"></div></div><div class=\"form-group\"><div class=\"col-md-offset-2 col-md-2\"><button type=\"submit\" class=\"btn btn-success\" ng-click=\"addUser(name, email, gender, level, hireDate)\">确定</button></div><div class=\"col-md-2\"><button type=\"reset\" class=\"btn btn-danger\">重置</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/back-auth/back-auth.html","<div class=\"dashboard-wrapper-lg\"><div class=\"row\"><div class=\"col-md-offset-2 col-md-8\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">权限管理</div></div><div class=\"widget-body\"><table class=\"table table-hover table-striped table-bordered\"><tr class=\"success\"><th>姓名</th><th>权限级别</th><th>权限管理</th></tr><tbody><tr ng-repeat=\"user in userList\"><td>{{user.name}}</td><td ng-show=\"!display\"><input type=\"text\" id=\"level_{{user.id}}\" ng-model=\"user.levelTrans\" class=\"inactive\" readonly=\"\"></td><td ng-show=\"editDisplay\"><label class=\"radio-inline\"><input type=\"radio\" name=\"super-admin\" value=\"1\" ng-model=\"user.newLevel\">超级管理员</label> <label class=\"radio-inline\"><input type=\"radio\" name=\"normal-admin\" value=\"2\" ng-model=\"user.newLevel\">普通管理员</label></td><td><edit ng-model=\"user\" ng-show=\"!showEdit\"><button class=\"btn btn-danger\">编辑</button></edit><update ng-model=\"user\" ng-show=\"showUpdate\"><button class=\"btn btn-danger\">更新</button></update><cancel ng-model=\"user\" ng-show=\"showCancel\"><button class=\"btn btn-warning\">取消</button></cancel></td></tr></tbody></table><pagination ng-model=\"currentPage\" total-items=\"length\" items-per-page=\"numPerPage\" max-size=\"maxSize\" boundary-links=\"true\"></pagination></div></div></div></div></div>");
$templateCache.put("app/back-userlist/back-userlist.html","<div class=\"dashboard-wrapper-lg\"><div class=\"row\"><div class=\"col-md-offset-2 col-md-8\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">管理员列表</div></div><div class=\"widget-body\"><table class=\"table table-hover table-striped table-bordered\"><tr class=\"success\"><th>姓名</th><th>性别</th><th>邮箱</th><th>权限级别</th><th>入职时间</th></tr><tbody><tr ng-repeat=\"user in userList\"><td>{{user.name}}</td><td>{{user.gender}}</td><td>{{user.email}}</td><td>{{user.levelTrans}}</td><td>{{user.hireDate}}</td></tr></tbody></table><pagination ng-model=\"currentPage\" total-items=\"length\" items-per-page=\"numPerPage\" max-size=\"maxSize\" boundary-links=\"true\"></pagination></div></div></div></div></div>");
$templateCache.put("app/blank/blank.html","");
$templateCache.put("app/dashboard/dashboard.html","<div class=\"dashboard-wrapper-lg\"><div class=\"row\"><div class=\"col-lg-3 col-md-3 col-sm-6\"><div class=\"mini-widget\"><div class=\"mini-widget-heading clearfix\"><div class=\"pull-left\">车主总数</div><div class=\"pull-right\"><i class=\"fa fa-angle-up\"></i> 12.2<sup>%</sup></div></div><div class=\"mini-widget-body clearfix\"><div class=\"pull-left\"><i class=\"fa fa-globe\"></i></div><div class=\"pull-right number\">{{data.totalUser}}</div></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-6\"><div class=\"mini-widget\"><div class=\"mini-widget-heading clearfix\"><div class=\"pull-left\">广告商总数</div><div class=\"pull-right\"><i class=\"fa fa-angle-up\"></i> 18.3<sup>%</sup></div></div><div class=\"mini-widget-body clearfix\"><div class=\"pull-left\"><i class=\"fa fa-twitter\"></i></div><div class=\"pull-right number\">{{data.totalAdvertiser}}</div></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-6\"><div class=\"mini-widget mini-widget-grey\"><div class=\"mini-widget-heading clearfix\"><div class=\"pull-left\">广告总数</div><div class=\"pull-right\"><i class=\"fa fa-angle-down\"></i> 21.9<sup>%</sup></div></div><div class=\"mini-widget-body clearfix\"><div class=\"pull-left\"><i class=\"fa fa-upload\"></i></div><div class=\"pull-right number\">{{data.totalAdvertisement}}</div></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-6\"><div class=\"mini-widget mini-widget-grey\"><div class=\"mini-widget-heading clearfix\"><div class=\"pull-left\">总投放量</div><div class=\"pull-right\"><i class=\"fa fa-angle-up\"></i> 67.1<sup>%</sup></div></div><div class=\"mini-widget-body clearfix\"><div class=\"pull-left\"><i class=\"fa fa-coffee\"></i></div><div class=\"pull-right number\">{{data.totalBroadcastTimes}}</div></div></div></div></div><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">最近一周广告投放</div></div><div class=\"widget-body\"><div id=\"area-chart\" class=\"chart-height-md\" style=\"height: 220px\"></div></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">广告投放量前三</div></div><div class=\"widget-body\"><div id=\"mobVsDesk\" class=\"chart-height-md\" style=\"height: 220px\"></div></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">最近一周收入统计</div></div><div class=\"widget-body\"><div id=\"mob-desktop\" class=\"chart-height-md\" style=\"height: 220px\"></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">对比统计</div></div><div class=\"widget-body\"><div class=\"social-stats\"><div class=\"row\"><div class=\"col-md-3 col-sm-3 col-xs-12\"><div class=\"social-icon facebook-bg\"><i class=\"fa fa-facebook fa-2x\"></i></div><div class=\"stats-details\"><h3>8985</h3><h6 class=\"text-success\">+ 21%</h6><h5>新增车主</h5></div></div><div class=\"col-md-3 col-sm-3 col-xs-12\"><div class=\"social-icon twitter-bg\"><i class=\"fa fa-twitter fa-2x\"></i></div><div class=\"stats-details\"><h3>4927</h3><h6 class=\"text-success\">+ 15%</h6><h5>新增广告商</h5></div></div><div class=\"col-md-3 col-sm-3 col-xs-12\"><div class=\"social-icon linkedin-bg\"><i class=\"fa fa-linkedin fa-2x\"></i></div><div class=\"stats-details\"><h3>764</h3><h6 class=\"text-success\">+ 11%</h6><h5>新增广告</h5></div></div><div class=\"col-md-3 col-sm-3 col-xs-12\"><div class=\"social-icon gplus-bg\"><i class=\"fa fa-google-plus fa-2x\"></i></div><div class=\"stats-details\"><h3>{{data.lastDayBroadcast}}</h3><h6 class=\"text-warning\">{{data.rate}}%</h6><h5>昨日投放量</h5></div></div></div></div></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">周下载量</div></div><div class=\"widget-body\"><div id=\"downloadChart\" class=\"chart-height-md\"></div></div></div></div></div></div>");
$templateCache.put("app/finance/finance.html","<div class=\"dashboard-wrapper-lg\"><div class=\"col-lg-10 col-lg-offset-1\"><div class=\"row\"><div class=\"col-lg-12 col-md-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">财务信息</div><span class=\"tools\"><i class=\"fa fa-cogs\"></i></span></div><div class=\"widget-body\"><table class=\"table table-responsive table-striped table-bordered table-hover no-margin\"><thead><tr><th style=\"width:20%\">事件</th><th style=\"width:20%\" class=\"hidden-xs\">用户ID</th><th style=\"width:20%\" class=\"hidden-xs\">资金账户</th><th style=\"width:20%\" class=\"hidden-xs\">金额</th><th style=\"width:10%\" class=\"hidden-xs\">操作日期</th><th style=\"width:10%\" class=\"hidden-xs\">经办人</th></tr></thead><tbody><tr ng-repeat=\"item in financeList\"><td>{{item.catalog}}</td><td>{{item.userId}}</td><td>{{item.account}}</td><td>{{item.money}}</td><td>{{item.completedDate}}</td><td>{{item.operatorName}}</td></tr></tbody></table><pagination ng-model=\"currentPage\" total-items=\"length\" items-per-page=\"numPerPage\" max-size=\"maxSize\" boundary-links=\"true\"></pagination></div></div></div></div></div></div>");
$templateCache.put("app/finance-cash/finance-cash.html","<div class=\"dashboard-wrapper-lg\"><div class=\"col-lg-10 col-lg-offset-1\"><div class=\"row\"><div class=\"col-lg-12 col-md-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">车主提现申请列表</div><span class=\"tools\"><i class=\"fa fa-cogs\"></i></span></div><div class=\"widget-body\"><table class=\"table table-responsive table-striped table-bordered table-hover no-margin\"><thead><tr><th style=\"width:20%\">用户名称</th><th style=\"width:17%\" class=\"hidden-xs\">用户ID</th><th style=\"width:17%\" class=\"hidden-xs\">提现账户</th><th style=\"width:10%\" class=\"hidden-xs\">提现金额</th><th style=\"width:20%\" class=\"hidden-xs\">申请日期</th><th style=\"width:16%\" class=\"hidden-xs\">操作</th></tr></thead><tbody><tr ng-repeat=\"item in cashApplyList\"><td><a ui-sref=\"app.user.detail-mobile\"><span class=\"name\">{{item.userName}}</span></a></td><td>{{item.userId}}</td><td>{{item.account}}</td><td>{{item.money}}</td><td>{{item.applyDate}}</td><td class=\"hidden-xs\"><div class=\"btn-group\"><button class=\"btn btn-default btn-xs\" data-toggle=\"modal\" data-target=\"#exampleModal\" ng-click=\"pass(item.id)\">完成提现</button> <button class=\"btn btn-default btn-xs\" data-toggle=\"modal\" data-target=\"#exampleModal\" ng-click=\"reject(item.id)\">拒绝提现</button></div></td></tr></tbody></table><pagination ng-model=\"currentPage\" total-items=\"length\" items-per-page=\"numPerPage\" max-size=\"maxSize\" boundary-links=\"true\"></pagination></div></div></div></div></div></div><div class=\"modal fade\" id=\"exampleModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"exampleModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"exampleModalLabel\">退款申请</h4></div><div class=\"modal-body\"><form><div class=\"form-group\"><label for=\"recipient-name\" class=\"control-label\">经办人:</label> <input type=\"text\" class=\"form-control\" id=\"recipient-name\" placeholder=\"经办人账号\" ng-model=\"username\"></div><div class=\"form-group\"><label for=\"message-text\" class=\"control-label\">密码:</label> <input type=\"password\" class=\"form-control\" id=\"recipient-name\" placeholder=\"请输入经办人密码\" ng-model=\"password\"></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">取消</button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"completeCash(username,password,tag,applyId)\">完成</button></div></div></div></div>");
$templateCache.put("app/finance-recharge/finance-recharge.html","<div class=\"dashboard-wrapper-lg\"><div class=\"col-lg-10 col-lg-offset-1\"><div class=\"row\"><div class=\"col-lg-12 col-md-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">广告商充值申请列表</div><span class=\"tools\"><i class=\"fa fa-cogs\"></i></span></div><div class=\"widget-body\"><table class=\"table table-responsive table-striped table-bordered table-hover no-margin\"><thead><tr><th style=\"width:20%\">用户名称</th><th style=\"width:17%\" class=\"hidden-xs\">用户ID</th><th style=\"width:17%\" class=\"hidden-xs\">充值账户</th><th style=\"width:10%\" class=\"hidden-xs\">充值金额</th><th style=\"width:20%\" class=\"hidden-xs\">申请日期</th><th style=\"width:16%\" class=\"hidden-xs\">操作</th></tr></thead><tbody><tr ng-repeat=\"item in rechargeApplyList\"><td><a ui-sref=\"app.user.detail-mobile\"><span class=\"name\">{{item.userName}}</span></a></td><td>{{item.userId}}</td><td>{{item.account}}</td><td>{{item.money}}</td><td>{{item.applyDate}}</td><td class=\"hidden-xs\"><div class=\"btn-group\"><button class=\"btn btn-default btn-xs\" data-toggle=\"modal\" data-target=\"#exampleModal\" ng-click=\"pass(item.id)\">完成充值</button> <button class=\"btn btn-default btn-xs\" data-toggle=\"modal\" data-target=\"#exampleModal\" ng-click=\"reject(item.id)\">拒绝充值</button></div></td></tr></tbody></table><pagination ng-model=\"currentPage\" total-items=\"length\" items-per-page=\"numPerPage\" max-size=\"maxSize\" boundary-links=\"true\"></pagination></div></div></div></div></div></div><div class=\"modal fade\" id=\"exampleModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"exampleModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"exampleModalLabel\">退款申请</h4></div><div class=\"modal-body\"><form><div class=\"form-group\"><label for=\"recipient-name\" class=\"control-label\">经办人:</label> <input type=\"text\" class=\"form-control\" id=\"recipient-name\" placeholder=\"经办人账号\" ng-model=\"username\"></div><div class=\"form-group\"><label for=\"message-text\" class=\"control-label\">密码:</label> <input type=\"password\" class=\"form-control\" id=\"recipient-name\" placeholder=\"请输入经办人密码\" ng-model=\"password\"></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">取消</button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"completeRecharge(username,password,tag,applyId)\">完成</button></div></div></div></div>");
$templateCache.put("app/finance-refund/finance-refund.html","<div class=\"dashboard-wrapper-lg\"><div class=\"col-lg-10 col-lg-offset-1\"><div class=\"row\"><div class=\"col-lg-12 col-md-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">广告商退款申请列表</div><span class=\"tools\"><i class=\"fa fa-cogs\"></i></span></div><div class=\"widget-body\"><table class=\"table table-responsive table-striped table-bordered table-hover no-margin\"><thead><tr><th style=\"width:20%\">用户名称</th><th style=\"width:17%\" class=\"hidden-xs\">用户ID</th><th style=\"width:17%\" class=\"hidden-xs\">退款账户</th><th style=\"width:10%\" class=\"hidden-xs\">账户余额</th><th style=\"width:20%\" class=\"hidden-xs\">申请日期</th><th style=\"width:16%\" class=\"hidden-xs\">操作</th></tr></thead><tbody><tr ng-repeat=\"item in refundApplyList\"><td><a ui-sref=\"app.user.detail-mobile\"><span class=\"name\">{{item.userName}}</span></a></td><td>{{item.userId}}</td><td>{{item.account}}</td><td>{{item.money}}</td><td>{{item.applyDate}}</td><td class=\"hidden-xs\"><div class=\"btn-group\"><button class=\"btn btn-default btn-xs\" data-toggle=\"modal\" data-target=\"#exampleModal\" ng-click=\"pass(item.id)\">完成退款</button> <button class=\"btn btn-default btn-xs\" data-toggle=\"modal\" data-target=\"#exampleModal\" ng-click=\"reject(item.id)\">拒绝退款</button></div></td></tr></tbody></table><pagination ng-model=\"currentPage\" total-items=\"length\" items-per-page=\"numPerPage\" max-size=\"maxSize\" boundary-links=\"true\"></pagination></div></div></div></div></div></div><div class=\"modal fade\" id=\"exampleModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"exampleModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"exampleModalLabel\">退款申请</h4></div><div class=\"modal-body\"><form><div class=\"form-group\"><label for=\"recipient-name\" class=\"control-label\">经办人:</label> <input type=\"text\" class=\"form-control\" id=\"recipient-name\" placeholder=\"经办人账号\" ng-model=\"username\"></div><div class=\"form-group\"><label for=\"message-text\" class=\"control-label\">密码:</label> <input type=\"password\" class=\"form-control\" id=\"recipient-name\" placeholder=\"请输入经办人密码\" ng-model=\"password\"></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">取消</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"completeCash(username,password,tag,applyId)\">完成</button></div></div></div></div>");
$templateCache.put("app/login/login.html","<div class=\"dashboard-container\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-md-offset-4\"><div class=\"sign-in-container\"><form action=\"invoice.html\" class=\"login-wrapper\"><div class=\"header\"><div class=\"row\"><div class=\"col-md-12 col-lg-12\"><h3>Login<img src=\"assets/images/logo1.png\" alt=\"Logo\" class=\"pull-right\"></h3></div></div></div><div class=\"content\"><form class=\"form-horizontal no-margin\"><div class=\"form-group\"><label for=\"userName\">User Name</label> <input type=\"text\" class=\"form-control\" id=\"userName\" placeholder=\"User Name\" ng-model=\"username\"></div><div class=\"form-group\"><label for=\"Password1\">Password</label> <input type=\"password\" class=\"form-control\" id=\"Password1\" placeholder=\"Password\" ng-model=\"password\"></div><div class=\"actions\"><input type=\"button\" class=\"btn btn-danger\" name=\"Login\" value=\"Login\" ng-click=\"login(username, password)\"> <a class=\"link\">Forgot Password?</a><div class=\"clearfix\"></div></div></form></div></form></div></div></div></div></div>");
$templateCache.put("app/statistics/statistics.html","<div class=\"dashboard-wrapper-lg\"><div class=\"row\"><div class=\"col-lg-10 col-lg-offset-1 col-md-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">用户审核</div></div><div class=\"widget-body\"><form class=\"form-horizontal no-margin\"><h4>MAD平台营收统计表</h4><hr style=\"margin-top:10px;\"><div class=\"for-group\"><div class=\"row\"><div id=\"chartdiv\" class=\"col-md-10 col-md-offset-1\" style=\"height:400px;\"></div></div></div><br><h4>公司收入、广告播放数比较</h4><hr style=\"margin-top:10px;\"><div class=\"form-group\"><div class=\"row\"><div id=\"incomeChart\" class=\"col-md-10 col-md-offset-1\" style=\"height:400px;\"></div></div></div></form></div></div></div></div></div>");
$templateCache.put("app/upload/upload.html","<div class=\"dashboard-wrapper-lg\"><div class=\"row\"><div class=\"col-lg-8 col-lg-offset-2 col-md-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">上传图片Demo</div></div><div class=\"widget-body\"><form class=\"form-horizontal no-margin\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">上传图片</label><div class=\"col-sm-10\"><button ng-file-select=\"onFileSelect($files)\" class=\"btn btn-large btn-info\" data-multiple=\"true\" title=\"select file\" onclick=\"this.value = null\">Click here to select file</button><ol><li ng-repeat=\"(k,v) in selectFiles\">{{v.file.name}} - {{v.progress.p}}% <button ng-click=\"abort(k)\">x</button></li></ol><label>{{upload.result}}</label> <a href=\"{{upload.picUrl}}\" ng-show=\"upload.isSuccess\">点击查看</a></div></div></form></div></div></div></div></div>");
$templateCache.put("app/user-check-advert/user-check-advert.html","<div class=\"modal fade\" id=\"exampleModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"exampleModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"exampleModalLabel\">未通过原因</h4></div><div class=\"modal-body\"><form><div class=\"form-group\"><textarea class=\"form-control\" id=\"message-text\" rows=\"8\" ng-model=\"reason\"></textarea></div><div class=\"form-group\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">取消</button><modal ng-model=\"advert\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"checkFailure(advert.id, 2, reason)\">提交</button></modal></div></form></div></div></div></div><div class=\"dashboard-wrapper-lg\"><div class=\"row\"><div class=\"col-lg-8 col-lg-offset-2 col-md-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">用户审核 <span class=\"mini-title\">审核广告商用户</span></div></div><div class=\"widget-body\"><form class=\"form-horizontal no-margin\"><h4>企业信息</h4><hr style=\"margin-top:10px;\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">单位类型</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.type}}</p><p></p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">企业名称</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.name}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">证件类型</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.licenseType}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">注册号</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.licenseCode}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">单位所在地</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.location}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">住所</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.accomodation}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">经营范围</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.businessScope}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">营业期限</label><div class=\"col-sm-3\"><p class=\"form-control-static\">{{advert.businessPeriod}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">组织机构代码</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.organizationCode}}</p></div></div><br><h4>法定代表人信息</h4><hr style=\"margin-top:10px;\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">法定代表人归属地</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.legalPersonLocation}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">法定代表人姓名</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.legalPersonName}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">身份证号</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.legalPersonId}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">证件有效期</label><div class=\"col-sm-3\"><p class=\"form-control-static\">{{advert.legalPersonValidDate}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">填写人身份</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.legalPersonIfLegalPerson}}</p></div></div><br><h4>联系方式</h4><hr style=\"margin-top:10px;\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">联系人邮箱</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.email}}</p></div></div><hr style=\"margin-top:10px;\"><div class=\"row\"><div class=\"text-center col-sm-3 col-sm-offset-3\"><button class=\"btn btn-success\" ng-click=\"checkSuccess(advert.id, 2)\" ng-show=\"!pass\">审核通过</button></div><div class=\"text-center col-sm-3\"><button type=\"button\" class=\"btn btn-danger\" data-toggle=\"modal\" data-target=\"#exampleModal\" ng-show=\"!notPass\">审核未通过</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/user-check-mobile/user-check-mobile.html","<div class=\"modal fade\" id=\"exampleModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"exampleModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"exampleModalLabel\">未通过原因</h4></div><div class=\"modal-body\"><form><div class=\"form-group\"><textarea class=\"form-control\" id=\"message-text\" rows=\"8\" ng-model=\"reason\"></textarea></div><div class=\"form-group\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">取消</button><modal ng-model=\"advert\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"checkFailure(mobile.id, 1, reason)\">提交</button></modal></div></form></div></div></div></div><div class=\"dashboard-wrapper-lg\"><div class=\"row\"><div class=\"col-lg-8 col-lg-offset-2 col-md-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">用户审核 <span class=\"mini-title\">审核车主用户</span></div></div><div class=\"widget-body\"><form class=\"form-horizontal no-margin\"><h4>车主信息</h4><hr style=\"margin-top:10px;\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">车主名称</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{mobile.name}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">用户ID</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{mobile.id}}</p></div></div><br><h4>车辆信息</h4><hr style=\"margin-top:10px;\"><div class=\"form-group\"><div class=\"col-sm-8 col-sm-offset-2 text-center\"><img src=\"{{mobile.vehicleLicenseImage}}\" width=\"100%\" alt=\"行驶证照片\"><br><label for=\"\" class=\"col-sm-offset-3 col-sm-4 control-label\">行驶证照片</label></div></div><br><h4>联系方式</h4><hr style=\"margin-top:10px;\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">车主电话</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{mobile.mobilePhone}}</p></div></div><hr style=\"margin-top:10px;\"><div class=\"row\"><div class=\"text-center col-sm-3 col-sm-offset-3\"><button class=\"btn btn-success\" ng-click=\"checkSuccess(mobile.id, 1)\" ng-show=\"!pass\">审核通过</button></div><div class=\"text-center col-sm-3\"><button type=\"button\" class=\"btn btn-danger\" data-toggle=\"modal\" data-target=\"#exampleModal\" ng-show=\"!notPass\">审核未通过</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/user-create/user-create.html","<div class=\"dashboard-wrapper-lg\"><div class=\"row\"><div class=\"col-lg-8 col-lg-offset-2 col-md-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">创建新用户 <span class=\"mini-title\">填入新用户信息</span></div></div><div class=\"widget-body\"><form class=\"form-horizontal no-margin\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">用户名称</label><div class=\"col-sm-6\"><input type=\"email\" class=\"form-control\" id=\"inputEmail3\" placeholder=\"用户名称\"></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">用户类别</label><div class=\"col-sm-6\"><label class=\"radio-inline\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"inlineRadio1\" value=\"option1\"> 车主用户</label> <label class=\"radio-inline\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"inlineRadio2\" value=\"option2\"> 广告商用户</label></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">用户邮箱</label><div class=\"col-sm-6\"><input type=\"email\" class=\"form-control\" id=\"inputEmail3\" placeholder=\"Email\"></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">初始密码</label><div class=\"col-sm-6\"><input type=\"password\" class=\"form-control\" id=\"inputPassword3\" placeholder=\"请输入六位及以上初始密码，必须包含字母和数字\"></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">确认密码</label><div class=\"col-sm-6\"><input type=\"password\" class=\"form-control\" id=\"inputPassword3\" placeholder=\"请再次输入密码\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-9\"><button type=\"submit\" class=\"btn btn-default\">创建用户</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/user-detail-advert/user-detail-advert.html","<div class=\"dashboard-wrapper-lg\"><div class=\"row\"><div class=\"col-lg-8 col-lg-offset-2 col-md-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">广告商用户详情</div></div><div class=\"widget-body\"><form class=\"form-horizontal no-margin\"><h4>企业信息</h4><hr style=\"margin-top:10px;\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">单位类型</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.type}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">企业名称</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.name}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">证件类型</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.licenseType}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">注册号</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.licenseCode}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">单位所在地</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.location}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">住所</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.accomodation}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">经营范围</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.businessScope}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">营业期限</label><div class=\"col-sm-3\"><p class=\"form-control-static\">{{advert.businessPeriod}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">组织机构代码</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.organizationCode}}</p></div></div><br><h4>法定代表人信息</h4><hr style=\"margin-top:10px;\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">法定代表人归属地</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.legalPersonLocation}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">法定代表人姓名</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.legalPersonName}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">身份证号</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.legalPersonId}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">证件有效期</label><div class=\"col-sm-3\"><p class=\"form-control-static\">{{advert.legalPersonValidDate}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">填写人身份</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.legalPersonIfLegalPerson}}</p></div></div><br><h4>联系方式</h4><hr style=\"margin-top:10px;\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">联系人邮箱</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{advert.email}}</p></div></div><hr style=\"margin-top:10px;\"><div class=\"row\"><div class=\"text-center col-sm-4 col-sm-offset-4\"><button class=\"btn btn-success\" ui-sref=\"app.user.list-advert\">返回</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/user-detail-mobile/user-detail-mobile.html","<div class=\"dashboard-wrapper-lg\"><div class=\"row\"><div class=\"col-lg-8 col-lg-offset-2 col-md-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">车主用户详情</div></div><div class=\"widget-body\"><form class=\"form-horizontal no-margin\"><h4>车主信息</h4><hr style=\"margin-top:10px;\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">车主名称</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{mobile.name}}</p></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">用户ID</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{mobile.id}}</p></div></div><br><h4>车辆信息</h4><hr style=\"margin-top:10px;\"><div class=\"form-group\"><div class=\"col-sm-8 col-sm-offset-2 text-center\"><img src=\"{{mobile.vehicleLicenseImage}}\" width=\"100%\" alt=\"行驶证照片\"><br><label for=\"\" class=\"col-sm-offset-3 col-sm-4 control-label\">行驶证照片</label></div></div><br><h4>联系方式</h4><hr style=\"margin-top:10px;\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">车主电话</label><div class=\"col-sm-9\"><p class=\"form-control-static\">{{mobile.mobilePhone}}</p></div></div><hr style=\"margin-top:10px;\"><div class=\"row\"><div class=\"text-center col-sm-4 col-sm-offset-4\"><button class=\"btn btn-success\" ui-sref=\"app.user\">返回</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/user-list-advert/user-list-advert.html","<div class=\"dashboard-wrapper-lg\"><div class=\"left-sidebar\"><div class=\"row\"><div class=\"col-lg-12 col-md-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">广告商用户列表</div><span class=\"tools\"><i class=\"fa fa-cogs\"></i></span></div><div class=\"widget-body\"><table class=\"table table-responsive table-striped table-bordered table-hover no-margin\"><thead><tr><th style=\"width:20%\">用户ID</th><th style=\"width:40%\" class=\"hidden-xs\">用户名称</th><th style=\"width:20%\" class=\"hidden-xs\">用户验证状态</th><th style=\"width:10%\" class=\"hidden-xs\">注册日期</th><th style=\"width:10%\" class=\"hidden-xs\">操作</th></tr></thead><tbody><tr ng-repeat=\"user in filtered=(userList | filter:filterByCategory)\"><td><a ui-sref=\"app.user.detail-mobile\" ng-click=\"getDetailById(user.id)\"><span class=\"name\">{{user.id}}</span></a></td><td>{{user.name}}</td><td><span class=\"label {{user.statusClass}}\">{{user.state}}</span></td><td>{{user.registrationDate}}</td><td class=\"hidden-xs\"><div class=\"btn-group\"><button ui-sref=\"{{user.uiSref}}\" class=\"btn btn-default btn-xs\" ng-click=\"getDetailById(user.id)\">{{user.operator}}</button></div></td></tr></tbody></table><pagination ng-model=\"currentPage\" total-items=\"length\" items-per-page=\"numPerPage\" max-size=\"maxSize\" boundary-links=\"true\"></pagination></div></div></div></div></div><div class=\"right-sidebar\"><div class=\"wrapper\"><table class=\"table table-condensed table-striped table-bordered table-hover no-margin\"><thead><tr><th style=\"width:10%\"></th><th style=\"width:70%\">用户状态</th><th style=\"width:20%\">标签</th></tr></thead><tbody><tr ng-repeat=\"cat in categories\"><td><input type=\"checkbox\" class=\"no-margin\" ng-model=\"filter[cat.status]\"></td><td><span class=\"name\">{{cat.name}}</span></td><td><span class=\"label {{cat.labelClass}}\">{{cat.info}}</span></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/user-list-mobile/user-list-mobile.html","<div class=\"dashboard-wrapper-lg\"><div class=\"left-sidebar\"><div class=\"row\"><div class=\"col-lg-12 col-md-12\"><div class=\"widget\"><div class=\"widget-header\"><div class=\"title\">车主用户列表</div><span class=\"tools\"><i class=\"fa fa-cogs\"></i></span></div><div class=\"widget-body\"><table class=\"table table-responsive table-striped table-bordered table-hover no-margin\"><thead><tr><th style=\"width:20%\">用户ID</th><th style=\"width:40%\" class=\"hidden-xs\">用户名称</th><th style=\"width:20%\" class=\"hidden-xs\">用户验证状态</th><th style=\"width:10%\" class=\"hidden-xs\">注册日期</th><th style=\"width:10%\" class=\"hidden-xs\">操作</th></tr></thead><tbody><tr ng-repeat=\"user in filtered=(userList | filter:filterByCategory)\"><td><a ui-sref=\"app.user.detail-mobile\" ng-click=\"getDetailById(user.id)\"><span class=\"name\">{{user.id}}</span></a></td><td>{{user.name}}</td><td><span class=\"label {{user.statusClass}}\">{{user.state}}</span></td><td>{{user.registrationDate}}</td><td class=\"hidden-xs\"><div class=\"btn-group\"><button ui-sref=\"{{user.uiSref}}\" class=\"btn btn-default btn-xs\" ng-click=\"getDetailById(user.id)\">{{user.operator}}</button></div></td></tr></tbody></table><pagination ng-model=\"currentPage\" total-items=\"length\" items-per-page=\"numPerPage\" max-size=\"maxSize\" boundary-links=\"true\"></pagination></div></div></div></div></div><div class=\"right-sidebar\"><div class=\"wrapper\"><table class=\"table table-condensed table-striped table-bordered table-hover no-margin\"><thead><tr><th style=\"width:10%\"></th><th style=\"width:70%\">用户状态</th><th style=\"width:20%\">标签</th></tr></thead><tbody><tr ng-repeat=\"cat in categories\"><td><input type=\"checkbox\" class=\"no-margin\" ng-model=\"filter[cat.status]\"></td><td><span class=\"name\">{{cat.name}}</span></td><td><span class=\"label {{cat.labelClass}}\">{{cat.info}}</span></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/components/footer/footer.html","<footer><p>Copyright 2016 &copy; MAD</p></footer>");
$templateCache.put("app/components/header/header.html","<header><a href=\"#/\" class=\"logo\"><img src=\"assets/images/logo2.png\" alt=\"Logo\"></a><div class=\"pull-right\"><ul id=\"mini-nav\" class=\"clearfix\"><li class=\"list-box dropdown\" ng-click=\"markMsg()\"><a id=\"drop5\" role=\"button\" class=\"dropdown-toggle\" data-toggle=\"dropdown\"><i class=\"fa fa-calendar\"></i></a> <span class=\"info-label success-bg\">{{msg.number}}</span><ul class=\"dropdown-menu server-activity\"><li ng-repeat=\"msg in msgList\" ng-click=\"refresh()\"><p><i class=\"fa fa-envelope {{msg.color}}\"></i> {{msg.msgContent}} <button class=\"close\" style=\"margin-top: 12px;color: red; margin-right: 5px\" aria-label=\"Close\" ng-click=\"delete(msg.id)\"><span aria-hidden=\"true\">&times;</span></button></p><span style=\"margin-left:45px\">{{msg.msgDate}}</span></li></ul></li><li class=\"list-box user-profile\"><a id=\"drop7\" role=\"button\" class=\"dropdown-toggle user-avtar\" data-toggle=\"dropdown\"><img src=\"assets/images/user5.png\" alt=\"Bluemoon User\"></a><ul class=\"dropdown-menu server-activity\"><li><p ui-sref=\"app.admin-info\"><i class=\"fa fa-cog text-info\"></i> Account Settings</p></li><li><div class=\"demo-btn-group clearfix\"><button class=\"btn btn-danger\" ng-click=\"logout()\">Logout</button></div></li></ul></li></ul></div></header>");
$templateCache.put("app/components/navbar/navbar.html","<div id=\"cssmenu\"><ul><li ng-class=\"{\'active\': isMain}\"><a ui-sref=\"app\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-home\"></i>首页</a></li><li ng-class=\"{\'active\': isUserManage}\"><a ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-bar-chart-o\"></i>用户管理</a><ul><li><a ui-sref=\"app.user\" ui-sref-opts=\"{reload: true}\">用户列表</a><ul><li><a ui-sref=\"app.user\" ui-sref-opts=\"{reload: true}\">车主用户</a></li><li><a ui-sref=\"app.user.list-advert\" ui-sref-opts=\"{reload: true}\">广告商用户</a></li></ul></li></ul></li><li ng-class=\"{\'active\': isAdManage}\"><a ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-table\"></i>广告管理</a><ul><li><a ui-sref=\"app.advert-audit\" ui-sref-opts=\"{reload: true}\">未审核广告</a></li><li><a ui-sref=\"app.advert-search\" ui-sref-opts=\"{reload: true}\">广告查询</a></li></ul></li><li ng-class=\"{\'active\': isFinanceManage}\"><a ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-suitcase\"></i>财务管理</a><ul><li><a ui-sref=\"app.finance\" ui-sref-opts=\"{reload: true}\">对账</a></li><li><a ui-sref=\"app.finance.cash\" ui-sref-opts=\"{reload: true}\">提现审核</a></li><li><a ui-sref=\"app.finance.refund\" ui-sref-opts=\"{reload: true}\">退款申请</a></li><li><a ui-sref=\"app.finance.recharge\" ui-sref-opts=\"{reload: true}\">充值申请</a></li></ul></li><li ng-class=\"{\'active\': isAdmin}\" my-access=\"ADMIN\" style=\"display: {{display}}\"><a ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-cloud\"></i>后台用户管理</a><ul><li><a ui-sref=\"app.admin-userlist\" ui-sref-opts=\"{reload: true}\">用户列表</a></li><li><a ui-sref=\"app.admin-adduser\" ui-sref-opts=\"{reload: true}\">添加后台用户</a></li><li><a ui-sref=\"app.admin-auth\" ui-sref-opts=\"{reload: true}\">权限管理</a></li></ul></li><li ng-class=\"{\'active\': isStatistics}\"><a ui-sref=\"app.statistics\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-home\"></i>统计信息</a></li></ul></div>");
$templateCache.put("app/components/sub-navbar/admin-info-sub-navbar.html","<div class=\"sub-nav hidden-sm hidden-xs\"><ul><li><a href=\"\" class=\"heading\">Admin Information</a></li></ul><div class=\"custom-search hidden-sm hidden-xs\"><input type=\"text\" class=\"search-query\" placeholder=\"Search here ...\"> <i class=\"fa fa-search\"></i></div></div>");
$templateCache.put("app/components/sub-navbar/advert-sub-navbar.html","<div class=\"sub-nav hidden-sm hidden-xs\"><ul><li><a href=\"\" class=\"heading\">广告管理</a></li><li class=\"hidden-sm hidden-xs\"><a href=\"#/advert/audit\" ng-class=\"{\'selected\': adaduit}\">未审核广告</a></li><li class=\"hidden-sm hidden-xs\"><a href=\"#/advert/search\" ng-class=\"{\'selected\': adsearch}\">广告查询</a></li></ul><div class=\"custom-search hidden-sm hidden-xs\"><input type=\"text\" class=\"search-query\" placeholder=\"Search here ...\"> <i class=\"fa fa-search\"></i></div></div>");
$templateCache.put("app/components/sub-navbar/back-userlist-sub-navbar.html","<div class=\"sub-nav hidden-sm hidden-xs\"><ul><li><a class=\"heading\">后台用户管理</a></li><li class=\"hidden-sm hidden-xs\"><a ui-sref=\"app.admin-userlist\" ng-class=\"{\'selected\': userlist}\">用户列表</a></li><li class=\"hidden-sm hidden-xs\"><a ui-sref=\"app.admin-adduser\" ng-class=\"{\'selected\': adduser}\">添加后台用户</a></li><li class=\"hidden-sm hidden-xs\"><a ui-sref=\"app.admin-auth\" ng-class=\"{\'selected\': userauth}\">权限管理</a></li></ul><div class=\"custom-search hidden-sm hidden-xs\"><input type=\"text\" class=\"search-query\" placeholder=\"Search here ...\"> <i class=\"fa fa-search\"></i></div></div>");
$templateCache.put("app/components/sub-navbar/dashboard-sub-navbar.html","<div class=\"sub-nav hidden-sm hidden-xs\"><ul><li><a href=\"\" class=\"heading\">Dashboard</a></li></ul><div class=\"custom-search hidden-sm hidden-xs\"><input type=\"text\" class=\"search-query\" placeholder=\"Search here ...\"> <i class=\"fa fa-search\"></i></div></div>");
$templateCache.put("app/components/sub-navbar/finance-sub-navbar.html","<div class=\"sub-nav hidden-sm hidden-xs\"><ul><li><a class=\"heading\">财务对账</a></li><li class=\"hidden-sm hidden-xs\"><a ui-sref=\"app.finance\" ng-class=\"{\'selected\': finance}\" ui-sref-opts=\"{reload: true}\">对账</a></li><li class=\"hidden-sm hidden-xs\"><a ui-sref=\"app.finance.cash\" ng-class=\"{\'selected\': financecash}\" ui-sref-opts=\"{reload: true}\">提现审核</a></li><li class=\"hidden-sm hidden-xs\"><a ui-sref=\"app.finance.refund\" ng-class=\"{\'selected\': financerefund}\" ui-sref-opts=\"{reload: true}\">退款审核</a></li><li class=\"hidden-sm hidden-xs\"><a ui-sref=\"app.finance.recharge\" ng-class=\"{\'selected\': financerecharge}\" ui-sref-opts=\"{reload: true}\">充值审核</a></li></ul><div class=\"custom-search hidden-sm hidden-xs\"><input type=\"text\" class=\"search-query\" placeholder=\"Search here ...\"> <i class=\"fa fa-search\"></i></div></div>");
$templateCache.put("app/components/sub-navbar/statistics-sub-navbar.html","<div class=\"sub-nav hidden-sm hidden-xs\"><ul><li><a href=\"\" class=\"heading\">统计信息</a></li></ul><div class=\"custom-search hidden-sm hidden-xs\"><input type=\"text\" class=\"search-query\" placeholder=\"Search here ...\"> <i class=\"fa fa-search\"></i></div></div>");
$templateCache.put("app/components/sub-navbar/user-check-sub-navbar.html","<div class=\"sub-nav hidden-sm hidden-xs\"><ul><li><a href=\"\" class=\"heading\">用户审核</a></li></ul><div class=\"custom-search hidden-sm hidden-xs\"><input type=\"text\" class=\"search-query\" placeholder=\"Search here ...\"> <i class=\"fa fa-search\"></i></div></div>");
$templateCache.put("app/components/sub-navbar/user-create-sub-navbar.html","<div class=\"sub-nav hidden-sm hidden-xs\"><ul><li><a href=\"\" class=\"heading\">创建新用户</a></li></ul><div class=\"custom-search hidden-sm hidden-xs\"><input type=\"text\" class=\"search-query\" placeholder=\"Search here ...\"> <i class=\"fa fa-search\"></i></div></div>");
$templateCache.put("app/components/sub-navbar/user-detail-sub-navbar.html","<div class=\"sub-nav hidden-sm hidden-xs\"><ul><li><a class=\"heading\">用户详情</a></li></ul><div class=\"custom-search hidden-sm hidden-xs\"><input type=\"text\" class=\"search-query\" placeholder=\"Search here ...\"> <i class=\"fa fa-search\"></i></div></div>");
$templateCache.put("app/components/sub-navbar/user-list-sub-navbar.html","<div class=\"sub-nav hidden-sm hidden-xs\"><ul><li><a href=\"\" class=\"heading\">用户列表</a></li><li class=\"hidden-sm hidden-xs\"><a ui-sref=\"app.user\" ng-class=\"{\'selected\': user}\">车主用户</a></li><li class=\"hidden-sm hidden-xs\"><a ui-sref=\"app.user.list-advert\" ng-class=\"{\'selected\': advert}\">广告商用户</a></li></ul><div class=\"custom-search hidden-sm hidden-xs\"><input type=\"text\" class=\"search-query\" placeholder=\"Search here ...\"> <i class=\"fa fa-search\"></i></div></div>");}]);